/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-mixed-operators */
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Calendar, Mic, MicOff, Trash, XCircle } from "react-feather";
import {
  ErrorToast,
  SuccessToast,
} from "app/shared/components/Popups/ToastMessage";
import {
  SEVERITY as SEVERITYOPTION,
  INCIDENT_TYPE,
  TYPE_ACT,
} from "app/shared/constants/GlobalArray";
import React, { Component } from "react";
import {
  convertDateToUTC,
  convertDateToUTCLATEST,
  formatLocalDate,
} from "app/shared/utility/tzUtilFunction";
import AsyncSelect from "react-select/async";
import AudioPlayer from "react-h5-audio-player";
import CommonDropdown from "./CommonDropdown";
import DatePicker from "react-datepicker";
import LoadingImage from "app/shared/components/Loader/LoadingImage";
import LowSpace from "app/shared/components/Popups/LowSpace";
//import MyDropzone from "app/shared/components/DocumentModal/Dropzone";
import ReportDropzone from "app/shared/components/DocumentModal/ReportDropZone";
import ProjectList from "./ProjectList";
import { ReactMic } from "react-mic";
import CompanyList from "./CompanyList";
import ServiceList from "./ServiceList";
import TimePicker from "react-times";
import Url from "app/shared/constants/Url";
import axios from "axios";
import moment from "moment";
import { requiredMessage } from "app/shared/constants/Messages";
import { withRouter } from "react-router-dom";
import SubmitImage from "../../../../assets/images/submit.png";
import { Scrollbars } from "react-custom-scrollbars";
import { ResolvePopup } from "app/shared/components/Popups";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import Axios from "axios";
import FetchEMList from "./services/fetchEMList";
import hardSet from "redux-persist/es/stateReconciler/hardSet";
import { subDays } from "date-fns";
const qs = require("qs");

const DEPT_URL = Url.departmentList;
const CONT_URL = Url.contractorList;
const ZONE_URL = Url.zoneList;
const ACT_URL = Url.activitylist;
const Div_URL = Url.divisionList;
const HZD_URL = Url.hazardList;
const BARRIER_URL = Url.barrierList;
const UAUC_PARAM_LIST = Url.summary.uaucformParameterList;
const NM_PARAM_LIST = Url.nmModule.springnmsavedformsetting;
const IRA_PARAM_LIST = Url.nmModule.springirasavedformsetting;

const ErrorMessage = <div className="invalid-feedback">Enter valid name</div>;
const ErrorBlock = ({ message }) => (
  <div className="invalid-feedback">{message || ""}</div>
);

export const SEVERITY = [
  {
    id: 4,
    name: "High Critical",
  },
  {
    id: 3,
    name: "High",
  },
  {
    id: 2,
    name: "Medium",
  },
  {
    id: 1,
    name: "Low",
  },
];

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    width: "100%",
    minHeight: "32px",
    maxHeight: "32px",
    border: "1px solid #E6E6E6",
    borderRadius: "6px",
    boxShadow: "none",
    "&:hover": {
      border: "1px solid #FF5A36",
    },
    backgroundColor: state.isDisabled ? "#F9F9F9" : "white",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    opacity: state.isDisabled ? 0.7 : 1,
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    height: "32px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "#444444",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#999",
    fontSize: "16px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#FFE5E0",
    borderRadius: "4px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "13px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#FF5A36",
    "&:hover": {
      backgroundColor: "#FF5A36",
      color: "white",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "#444444",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    width: "100%",
    zIndex: 9999,
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#FF5A36"
      : state.isFocused
        ? "#FFE5E0"
        : "white",
    color: state.isSelected ? "white" : "#444444",
    cursor: "pointer",
    padding: "10px 12px",
    fontSize: "14px",
    "&:active": {
      backgroundColor: "#FF5A36",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#999",
    padding: "0 8px",
    "&:hover": {
      color: "#FF5A36",
    },
  }),
};

class NmReport extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      formHideField: this.props.hideFieldList,
      reportType: this.props.reportType,
      tempFiles: [],
      companyList: [],
      serviceList: [],
      projectList: [],
      departmentList: [],
      contractorList: [],
      divisionList: [],
      searchFiledUsers: [],
      searchEmployeeUsers: [],
      zoneList: [],
      searchData: [],
      searchEmployeeData: [],
      locationList: [],
      closingRightUserList: [],
      typeActList: TYPE_ACT,
      typeIncidentList: INCIDENT_TYPE,
      activityList: [],
      sourceId: null,
      severityList: this.props.reportType === "nm" ? SEVERITY : SEVERITYOPTION,
      barrierList: [],
      hazardList: [],
      subHazardList: [],
      controlMeasureList: [],
      selectedControlMeasureIds: [],
      // ── UAUC (soi) risk-register mode (organisation setting ON) ──
      organisationSetting: true, // default ON (also on API failure)
      riskRegisterTree: null, // /riskRegister/getByActivity response
      subActivityList: [],
      selectedSubActivity: null,
      subActivityError: false,
      subHazardError: false,
      projectAutoFill: {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      },
      clearDropZone: false,
      observationText: "",
      evidenceFileList: [],
      evidenceUrlList: [],
      selectedCompanyId: null,
      selectedServiceId: null,
      selectedProjectId: null,
      selectedDepartmentId: null,
      selectedContractorId: null,
      selectedZoneId: null,
      selectedLocationId: null,
      selectedClosingRightUserId: null,
      selectedTypeAct: null,
      selectedActivity: null,
      selectedSeverity: null,
      selectedBarrier: null,
      selectedHazardId: null,
      selectedSubHazardId: null,
      selectedDivisionId: null,
      //  selectedControlMeasureId: null,
      selectedIncidentTypeId: 0,
      selectedTargetDate: new Date(),
      maxDatepickerDate: new Date(),
      controlMeasure: "",
      resolveCheckbox: 0,

      selectedIncidentDate: new Date(),
      selectedIncidentTime: moment().format("HH:mm"),
      selectedTimeMeridiem: moment().format("A"),
      personName: "",
      personNameList: [],
      lat: 0,
      long: 0,
      userData: JSON.parse(localStorage.getItem("userData")),
      observationError: false,
      serviceError: false,
      projectError: false,

      zoneError: false,
      departmentError: false,
      contractorError: false,
      divisionError: false,
      locationError: false,
      closingRightUserError: false,
      resolveError: false,
      typeActError: false,
      activityError: false,
      severityError: false,
      incidentTypeError: false,
      barrierError: false,
      hazardError: false,
      controlMeasureError: false,
      incidentTypeError: false,
      showRecorderModal: false,
      recordAudio: false,
      controlMeasureAudio: "",
      controlMeasureURL: "",
      observationAudio: "",
      observationURL: "",
      recordingFor: "observation",
      voilatorPersonList: [],
      voilatorPersonName: "",
      voilatorId: "",
      voilatorIdList: [],
      sucesssPopup: false,
      reportNumber: null,
      lowStorageMessage: "",
      lowStorageStatus: 200,
      showLowStoragePopup: false,
      showContractorDropdown: true,
      showZoneDropdown: true,
      showLocationDropdown: true,
      selectedFile: "",

      // file:[],
      incidentPersonNameError: false,
      showResolveModal: false,
      selectedDate: new Date(),
    };
    this.timeout = 0;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.hideFieldList !== prevState.formHideField) {
      return nextProps.hideFieldList;
    }
    return null;
  }

  _closeSuccessPopup = async () => {
    await this.setState({ sucesssPopup: false });
    await this._clearForm();
    this.props.close();
    this.props.history.push("/", { refresh: true });
  };

  _continueReporting = async () => {
    await this.setState({ sucesssPopup: false });
    await this._continueReportingClearForm();

    // await this._fetchServiceList();

    await this.setState((prevState) => {
      let { severityList, typeActList, typeIncidentList } = prevState;
      severityList = this.props.reportType === "nm" ? SEVERITY : SEVERITYOPTION;
      typeActList = TYPE_ACT;
      typeIncidentList = INCIDENT_TYPE;

      return { severityList, typeActList, typeIncidentList };
    });
  };

  _getLocation = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState((prevState) => {
          let { lat, long } = prevState;
          lat = position.coords.latitude;
          long = position.coords.longitude;
          return { lat, long };
        });
      });
    }
  };

  componentDidMount = async () => {
    if (
      this.props.reportType === "soi" ||
      this.props.reportType === "ira" ||
      this.props.reportType === "nm"
    ) {
      const organisationSetting = await this._fetchOrganisationSetting();

      if (organisationSetting) {
        await this._fetchCompanyList();
      } else {
        await this._fetchServiceList();
      }
    } else {
      await this._fetchServiceList();
    }

    await this._getLocation();
    this.props.setClick(
      this.props.reportType == "ira" ? this._submitSOIIra : this._submitSOI,
    );

    this._fetchParamList(true);
  };

  // ── UAUC (soi) risk-register mode helpers ─────────────────────────────────
  _getDb = () => {
    const hostname = window.location.hostname.toLowerCase();

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "stageclide";
    }

    if (hostname.endsWith(".clideanalyser.in")) {
      const db = hostname.replace(".clideanalyser.in", "").trim();

      if (db === "qaclide") {
        return "stageclide";
      }

      return db;
    }

    return hostname.split(".")[0] || "stageclide";
  };

  _fetchOrganisationSetting = async () => {
    try {
      const response = await axios.get(Url.organisationSettingByDb, {
        params: { db: this._getDb() },
      });

      const enabled = !!response?.data?.data?.organisationSetting;

      this.setState({ organisationSetting: enabled });

      return enabled;
    } catch (error) {
      this.setState({ organisationSetting: true });
      return true; // fallback
    }
  };

  // True for UAUC (soi), Near Miss (nm), and IRA when the organisation setting is ON.
  _isRiskRegisterMode = () =>
    (this.state.reportType === "soi" ||
      this.state.reportType === "ira" ||
      this.state.reportType === "nm") &&
    this.state.organisationSetting;

  _mapRrHazards = (arr) =>
    (arr || []).map((h) => ({ name: h.hazardName, id: h.hazardId }));

  _mapRrSubHazards = (arr) =>
    (arr || []).map((sh) => ({ name: sh.subHazardName, id: sh.subHazardId }));

  _mapRrControlMeasures = (node) => {
    if (!node) return [];
    const existing = (node.existingControlMeasures || []).map((c) => ({
      controlMeasure: c.controlMeasure,
      id: c.controlMeasureId,
    }));
    const recommended = (node.recommendedControlMeasures || []).map((c) => ({
      controlMeasure: c.controlMeasure,
      id: c.controlMeasureId,
    }));
    return [...existing, ...recommended];
  };

  // Hazards for the current selection: under the chosen sub-activity, else directly under the activity.
  _currentRrHazards = () => {
    const tree = this.state.riskRegisterTree;
    if (!tree) return [];
    if (tree.subActivities && tree.subActivities.length) {
      const sa = tree.subActivities.find(
        (s) => s.subActivityId == this.state.selectedSubActivity,
      );
      return sa?.hazards || [];
    }
    return tree.hazards || [];
  };

  // Fetch the risk-register tree for an activity and seed the dropdowns.
  _fetchRiskRegisterByActivity = async (activityId) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("springToken");
    try {
      const response = await axios.get(Url.riskRegisterByActivity, {
        params: { user_id: userId, auth_key: token, activityId },
        headers: { accept: "application/json" },
      });
      const data = response?.data?.data || null;
      const subActivities = data?.subActivities || [];
      this.setState({
        riskRegisterTree: data,
        subActivityList: subActivities.map((sa) => ({
          name: sa.sub_activity_name || sa.subActivityName || sa.name || "",
          id: sa.sub_activity_id || sa.subActivityId || sa.id || 0,
        })),
        selectedSubActivity: null,
        subActivityError: false,
        // Sub Activity OFF → hazards come directly under the activity
        hazardList: subActivities.length
          ? []
          : this._mapRrHazards(data?.hazards),
        selectedHazardId: null,
        subHazardList: [],
        selectedSubHazardId: null,
        controlMeasureList: [],
        selectedControlMeasureIds: [],
      });
    } catch (error) {
      this.setState({
        riskRegisterTree: null,
        subActivityList: [],
        hazardList: [],
      });
    }
  };

  _subActivityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSubActivity, subActivityError } = prevState;
      selectedSubActivity = id;
      subActivityError = id ? false : true;
      return { selectedSubActivity, subActivityError };
    });

    if (this._isRiskRegisterMode()) {
      const sa = (this.state.riskRegisterTree?.subActivities || []).find(
        (s) => s.subActivityId == id,
      );
      await this.setState({
        hazardList: this._mapRrHazards(sa?.hazards),
        selectedHazardId: null,
        subHazardList: [],
        selectedSubHazardId: null,
        controlMeasureList: [],
        selectedControlMeasureIds: [],
      });
    }
  };

  _dynamicObservationPlaceHolder = () => {
    let text = this.props.t("writeUaucDescription");

    let { reportType } = this.state;

    if (reportType == "nm") {
      text = this.props.t("writeNearMissDescription");
    } else if (reportType == "ira") {
      text = this.props.t("writeIraDescription");
    } else if (reportType == "gp") {
      text = this.props.t("writeGoodPracticesDescription");
    }

    return text;
  };

  _fetchOptionList = async (firstRender = false) => {
    const tempUserId = localStorage.getItem("userId");
    const tempToken = localStorage.getItem("token");
    const tempSpringToken = localStorage.getItem("springToken");

    let requestData = {
      auth_key: tempToken,
      user_id: tempUserId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
    };

    const ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    if (this.state.userData?.div_dept == 0) this._fetchDepartmentList();

    const requests = [
      axios.post(CONT_URL, qs.stringify(requestData), { headers: ContentType }),
      axios.post(ZONE_URL, qs.stringify(requestData), { headers: ContentType }),
      axios.post(HZD_URL, qs.stringify(requestData), { headers: ContentType }),
      axios.post(
        Div_URL,
        qs.stringify({ ...requestData, auth_key: tempSpringToken }),
        {
          headers: ContentType,
        },
      ),
    ];

    // 🚫 Do NOT fetch Activity & Barrier on first render
    if (!firstRender) {
      requests.push(
        axios.post(ACT_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
        axios.post(BARRIER_URL, qs.stringify(requestData), {
          headers: ContentType,
        }),
      );
    }

    try {
      const responses = await axios.all(requests);

      this.setState({
        contractorList:
          responses[0].data.status === 200 ? responses[0].data.data : [],
        zoneList:
          responses[1].data.status === 200 ? responses[1].data.data : [],
        hazardList:
          responses[2].data.status === 200 ? responses[2].data.data : [],
        divisionList:
          responses[3].data.status === 200 ? responses[3].data.data : [],
        activityList:
          !firstRender && responses[4]?.data.status === 200
            ? responses[4].data.data
            : [],
        barrierList:
          !firstRender && responses[5]?.data.status === 200
            ? responses[5].data.data
            : [],
        dataLoading: false,
      });
    } catch (err) {
      this._setDataLoading(false);
    }

    if (this.state.userData?.designation_flag == 6) {
      this._fetchClosingRightUserListPsh();
    }
  };

  fetchHazrdList = async (selectedActivity) => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      activity_id: selectedActivity,
    };

    let URL = Url.hazardList;

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    await axios
      .post(URL, qs.stringify(requestData), ContentType)
      .then(async (response) => {
        if (response.data.status == 200) {
          await this.setState({
            hazardList: response.data.data,
          });
        }
      })
      .catch(async (error) => {
        await this.setState({
          dataLoading: false,
        });
      });
  };

  fetchControlMeasureList = async () => {
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");

    let requestParams = {
      auth_key: token,
      user_id: userId,
      activityId: this.state.selectedActivity,
    };

    let URL = Url.controlMeasureListSpring;

    await axios
      .get(`${URL}?search=${encodeURIComponent("")}`, {
        params: requestParams,
        headers: {
          accept: "application/json",
        },
      })
      .then(async (response) => {
        if (response.data.status == 200) {
          await this.setState({
            controlMeasureList: response.data.data,
          });
        }
      })
      .catch(async (error) => {
        await this.setState({
          dataLoading: false,
        });
      });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _fetchCompanyList = async () => {
    let params = {
      page: 0,
      size: 200,
      search: "",
      softdelete: 0,
      softDelete: 0,
    };
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPIGet(Url.companyList, params);

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { companyList } = prevState;
              companyList = response.data.data;
              return { companyList };
            });

            if (this.state.userData.designation_flag === 4) {
              this.setState(
                {
                  selectedCompanyId: response.data.data[0]["companyId"],
                },
                () =>
                  void this._fetchServiceList(
                    response.data.data[0]["companyId"],
                  ),
              );
            }

            this._setDataLoading(false);
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchServiceList = async (companyId = null) => {
    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.serviceList,
        { "Content-Type": "application/x-www-form-urlencoded" },
        { company_id: companyId },
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { serviceList } = prevState;
              serviceList = response.data.data;
              return { serviceList };
            });
            if (this.state.userData.designation_flag === 4) {
              this.setState(
                {
                  selectedServiceId: response.data.data[0]["service_id"],
                },
                () =>
                  void this._fetchProjectList(
                    response.data.data[0]["service_id"],
                  ),
              );
            }
            this._setDataLoading(false);
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _serviceChangeHandle = async (serviceId) => {
    await this.setState((prevState) => {
      let { selectedServiceId, serviceError } = prevState;
      selectedServiceId = serviceId;
      serviceError = serviceId ? false : true;
      return { selectedServiceId, serviceError };
    });
    await this._resetDropdwon();
    this._fetchProjectList(serviceId);
  };

  _companyChangeHandle = async (companyId) => {
    await this.setState((prevState) => {
      let { selectedCompanyId, companyError } = prevState;
      selectedCompanyId = companyId;
      companyError = companyId ? false : true;
      return { selectedCompanyId, companyError };
    });
    this.setState({ selectedServiceId: null, serviceList: [] });
    await this._resetDropdwon();

    if (companyId) {
      this._fetchServiceList(companyId);
    }
  };

  _resetDropdwon = async (projectReset = true) => {
    await this.setState((prevState) => {
      let {
        selectedHazardId,
        selectedSubHazardId,
        selectedProjectId,
        selectedContractorId,
        selectedDepartmentId,
        selectedActivity,
        selectedLocationId,
        selectedClosingRightUserId,
        selectedZoneId,
        selectedBarrier,
        hazardList,
        subHazardList,
        projectList,
        contractorList,
        departmentList,
        activityList,
        locationList,
        closingRightUserList,
        barrierList,
        zoneList,
        controlMeasureList,
        selectedControlMeasureIds,
      } = prevState;

      if (projectReset) {
        selectedProjectId = null;
        projectList = [];
      }

      selectedHazardId = null;
      selectedSubHazardId = null;
      selectedContractorId = null;
      selectedActivity = null;
      selectedLocationId = null;
      selectedClosingRightUserId = null;
      selectedBarrier = null;
      selectedDepartmentId = null;
      selectedZoneId = null;

      hazardList = [];
      subHazardList = [];
      departmentList = [];
      contractorList = [];
      locationList = [];
      closingRightUserList = [];
      barrierList = [];
      activityList = [];
      zoneList = [];
      controlMeasureList = [];
      selectedControlMeasureIds = [];

      return {
        selectedHazardId,
        selectedProjectId,
        selectedSubHazardId,
        selectedContractorId,
        selectedDepartmentId,
        selectedActivity,
        selectedLocationId,
        selectedZoneId,
        selectedBarrier,
        hazardList,
        subHazardList,
        projectList,
        contractorList,
        departmentList,
        activityList,
        locationList,
        closingRightUserList,
        barrierList,
        zoneList,
        controlMeasureList,
        selectedControlMeasureIds,
      };
    });
  };

  _fetchProjectList = async (serviceId) => {
    const { reportType } = this.state;

    let moduleName = "uauc";
    if (reportType == "soi") {
      moduleName = "UAUC";
    } else if (reportType == "nm") {
      moduleName = "Near Miss";
    } else if (reportType == "ira") {
      moduleName = "IRA";
    }

    let requestData = {
      service_id: serviceId,
      // module_id: moduleId,
      module_name: moduleName,
    };

    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        Url.projectListForm,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { projectList } = prevState;
              projectList = response.data.data;
              return { projectList };
            });
            if (this.state.userData.designation_flag === 4) {
              const project = response.data.data[0];
              const { project_id, contractor_flag, zone_location_flag } =
                project;
              this.setState(
                {
                  selectedProjectId: project_id,
                  // selectedContractorId: contractor_flag,
                  // selectedZoneId: zone_location_flag,
                  showContractorDropdown: Boolean(contractor_flag),
                  showLocationDropdown: Boolean(zone_location_flag),
                  showZoneDropdown: Boolean(zone_location_flag),
                  // selectedLocationId: zone_location_flag
                  ...(this._isRiskRegisterMode()
                    ? {
                        projectAutoFill: {
                          projectCategory: project.project_category ?? "",
                          projectCategoryId:
                            project.project_category_id ??
                            project.projectCategoryId ??
                            project.project_category ??
                            "",
                          region: project.region ?? "",
                          state: project.state ?? "",
                          city: project.city ?? "",
                        },
                      }
                    : {}),
                },
                () => {
                  void this._fetchParamList();
                  void this._fetchOptionList();
                },
              );
            }
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _projectChangeHandle = async (projectId) => {
    const project = this.state.projectList.find(
      (data) => data.project_id == projectId,
    );

    if (project?.status === 1) {
      ErrorToast("Selected project cannot be used, please contact admin");
      await this._resetDropdwon(true);
      this._fetchProjectList(this.state.selectedServiceId);
      return;
    }

    if (projectId) {
      await this._resetDropdwon(false);

      await this.setState((prevState) => {
        let {
          selectedProjectId,
          projectError,
          showContractorDropdown,
          showZoneDropdown,
          showLocationDropdown,
          projectList,
        } = prevState;

        // check contractor flag
        let index = projectList.findIndex(
          (item) => projectId == item.project_id,
        );
        const isContractor = projectList[index].contractor_flag;
        showContractorDropdown = isContractor == 0 ? false : true;

        const isZone = projectList[index].zone_location_flag;
        showZoneDropdown = isZone == 0 ? false : true;

        const isLocation = projectList[index].zone_location_flag;
        showLocationDropdown = isLocation == 0 ? false : true;

        selectedProjectId = projectId;
        projectError = projectId ? false : true;

        return {
          selectedProjectId,
          projectError,
          showContractorDropdown,
          showZoneDropdown,
          showLocationDropdown,
        };
      });

      // UAUC + setting ON → auto-fill Project Details from the selected project
      if (this._isRiskRegisterMode() && project) {
        this.setState({
          projectAutoFill: {
            projectCategory: project.project_category ?? "",
            // projectlistform returns project_category as a string; use the id field if present
            projectCategoryId:
              project.project_category_id ??
              project.projectCategoryId ??
              project.project_category ??
              "",
            region: project.region ?? "",
            state: project.state ?? "",
            city: project.city ?? "",
          },
        });
      }

      await this._fetchOptionList();
    } else {
      await this._resetDropdwon(true);
    }
  };

  _zoneChangeHandle = async (zoneId) => {
    await this.setState((prevState) => {
      let {
        selectedZoneId,
        departmentError,
        contractorError,
        // locationError,
        zoneError,
      } = prevState;
      selectedZoneId = zoneId;
      zoneError = zoneId ? false : true;

      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedZoneId,
        isValidContactor: !!selectedZoneId,
        // isValidLocation: !!selectedZoneId,
        isValidZone: !!selectedZoneId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        // isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        departmentError = !selectedZoneId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        contractorError = !selectedZoneId;
      }

      // if (isFieldShownMapAndValid.isShownLocation) {
      //   locationError = !selectedZoneId;
      // }

      return {
        selectedZoneId,
        departmentError,
        contractorError,
        // locationError,
        zoneError,
      };
    });

    await this._fetchLocationList();
    // await this._fetchClosingRightUserList();
  };

  _fetchLocationList = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      zone_id: this.state.selectedZoneId,
      // zone_id: zoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.locationList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { locationList } = prevState;
              locationList = response.data.data;
              return { locationList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchDepartmentList = async () => {
    let requestData = {
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      divisionId: this.state.selectedDivisionId,
      // zone_id: zoneId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPISpring(
        DEPT_URL,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { departmentList } = prevState;
              departmentList = response.data.data;
              return { departmentList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchSubHazardList = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    let requestData = {
      auth_key: token,
      user_id: userId,
      hazard_Id: this.state.selectedHazardId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.subhazardList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { subHazardList } = prevState;
              subHazardList = response.data.data;
              return { subHazardList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _hazardChangeHandle = async (hazardId) => {
    await this.setState((prevState) => {
      let { selectedHazardId, hazardError } = prevState;
      selectedHazardId = hazardId;

      if (this.state.reportType === "soi") {
        hazardError = hazardId ? false : true;
      }

      return { selectedHazardId, hazardError };
    });

    // UAUC + setting ON → sub-hazards / control measures come from the tree
    if (this._isRiskRegisterMode()) {
      const hz = this._currentRrHazards().find((h) => h.hazardId == hazardId);
      const subHazards = hz?.subHazards || [];
      await this.setState({
        subHazardList: this._mapRrSubHazards(subHazards),
        selectedSubHazardId: null,
        // Sub Hazard OFF → control measures come directly under the hazard
        controlMeasureList: subHazards.length
          ? []
          : this._mapRrControlMeasures(hz),
        selectedControlMeasureIds: [],
      });
      return;
    }

    await this._fetchSubHazardList();
  };

  _controlMeasureChangeHandle = async (controlMeasureId) => {
    let text = this.props.t("writeControlMeasure");

    await this.setState((prevState) => {
      let {
        selectedControlMeasureIds,
        controlMeasureError,
        controlMeasureList,
      } = prevState;
      const updatedSelectedControlMeasureIds = [...selectedControlMeasureIds];
      updatedSelectedControlMeasureIds.push(
        controlMeasureList.find((item) => item.id == controlMeasureId),
      );

      controlMeasureList = controlMeasureList.filter(
        (item) => item.id != controlMeasureId,
      );
      return {
        selectedControlMeasureIds: updatedSelectedControlMeasureIds,
        controlMeasureError,
        controlMeasureList,
        text,
      };
    });
  };

  _removeControlMeasure = async (removeId) => {
    let text = this.props.t("writeControlMeasureDescription");
    const updateCmlist = this.state.selectedControlMeasureIds.filter(
      (item) => item.id !== removeId,
    );

    this.state.selectedControlMeasureIds.map((data) => {
      if (data.id === removeId) {
        this.setState({
          controlMeasureList: [...this.state.controlMeasureList, data],
        });
      }
      return text;
    });

    this.setState({
      selectedControlMeasureIds: updateCmlist,
    });
  };

  _departmentChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let {
        selectedDepartmentId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      } = prevState;
      selectedDepartmentId = id;
      departmentError = id ? false : true;
      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedDepartmentId,
        isValidContactor: !!selectedDepartmentId,
        isValidLocation: !!selectedDepartmentId,
        isValidZone: !!selectedDepartmentId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        departmentError = !selectedDepartmentId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        contractorError = !selectedDepartmentId;
      }

      if (
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        locationError = !selectedDepartmentId;
        zoneError = !selectedDepartmentId;
      }

      return {
        selectedDepartmentId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      };
    });
    if (this.state.userData?.designation_flag != 6)
      await this._fetchClosingRightUserList();
  };

  _locationChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let {
        selectedLocationId,
        departmentError,
        contractorError,
        locationError,
      } = prevState;
      selectedLocationId = id;
      locationError = id ? false : true;

      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedLocationId,
        isValidContactor: !!selectedLocationId,
        isValidLocation: !!selectedLocationId,
        isValidZone: !!selectedLocationId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        // departmentError = !prevState.selectedDepartmentId;
        departmentError = !selectedLocationId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        //contractorError = !prevState.selectedContractorId;
        contractorError = !selectedLocationId;
      }

      return {
        selectedLocationId,
        locationError,
        departmentError,
        contractorError,
      };
    });
    if (this.state.userData?.designation_flag != 6)
      await this._fetchClosingRightUserList();
  };

  _closingRightUserChangeHandle = async (id) => {
    if (id === "0" || id === 0) {
      this._handleChange(true, "resolve_checkbox");
      return;
    }
    await this.setState((prevState) => {
      let {
        selectedClosingRightUserId,
        closingRightUserError,
        resolveError,
        resolveCheckbox,
        isCheckboxChecked,
      } = prevState;
      selectedClosingRightUserId = id;
      closingRightUserError = false;
      resolveCheckbox = 0;
      resolveError = false;
      isCheckboxChecked = false;
      return {
        selectedClosingRightUserId,
        closingRightUserError,
        resolveError,
        resolveCheckbox,
        isCheckboxChecked,
      };
    });
    if (this.state.userData?.designation_flag != 6)
      await this._fetchClosingRightUserList();
  };

  _fetchClosingRightUserList = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
      // zone_id: this.state.selectedZoneId,
      department_id: this.state.selectedDepartmentId,
      contractor_id: this.state.selectedContractorId,
      location_id: this.state.selectedLocationId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.closingRightUserList,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { closingRightUserList } = prevState;
              closingRightUserList = response.data.data;
              return { closingRightUserList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _fetchClosingRightUserListPsh = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    let requestData = {
      auth_key: token,
      user_id: userId,
      service_id: this.state.selectedServiceId,
      project_id: this.state.selectedProjectId,
    };
    var ContentType = {
      "Content-Type": "application/x-www-form-urlencoded",
    };

    import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.closingRightUserListPsh,
        ContentType,
        requestData,
      );

      responseObj
        .then(async (response) => {
          if (response.data.status === 200) {
            await this.setState((prevState) => {
              let { closingRightUserList } = prevState;
              closingRightUserList = [
                ...closingRightUserList,
                ...response.data.data,
              ];
              return { closingRightUserList };
            });
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
    });
  };

  _subHazardChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedSubHazardId, subHazardError } = prevState;
      selectedSubHazardId = id;
      subHazardError = id ? false : true;
      return { selectedSubHazardId, subHazardError };
    });

    // UAUC + setting ON → control measures come from the selected sub-hazard
    if (this._isRiskRegisterMode()) {
      const hz = this._currentRrHazards().find(
        (h) => h.hazardId == this.state.selectedHazardId,
      );
      const sh = (hz?.subHazards || []).find((s) => s.subHazardId == id);
      await this.setState({
        controlMeasureList: this._mapRrControlMeasures(sh),
        selectedControlMeasureIds: [],
      });
    }
  };

  _barrierChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedBarrier, barrierError } = prevState;
      selectedBarrier = id;

      if (this.state.reportType === "soi") {
        barrierError = id ? false : true;
      }

      return { selectedBarrier, barrierError };
    });
  };

  _activityChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedActivity, activityError } = prevState;
      selectedActivity = id;
      activityError = id ? false : true;
      return { selectedActivity, activityError };
    });
    // UAUC + organisation setting ON → drive the cascade from the risk register tree
    if (this._isRiskRegisterMode()) {
      await this._fetchRiskRegisterByActivity(id);
      return;
    }

    if (this.state.param_list?.subActivity) {
      const selectedAct = (this.state.activityList || []).find(
        (act) => act.id == id || act.activityId == id,
      );
      const subActivities = selectedAct?.subActivities || [];
      await this.setState({
        subActivityList: subActivities.map((sa) => {
          if (typeof sa === "string") {
            return { name: sa, id: sa };
          }
          return {
            name: sa.sub_activity_name || sa.subActivityName || sa.name || "",
            id: sa.sub_activity_id || sa.subActivityId || sa.id || 0,
          };
        }),
        selectedSubActivity: null,
        subActivityError: false,
      });
    }

    await this.fetchHazrdList(id);
    await this.fetchControlMeasureList(id);
  };

  _contractorChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let {
        selectedContractorId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      } = prevState;
      selectedContractorId = id;
      contractorError = id ? false : true;

      const isFieldShownMapAndValid = {
        isValidDepartment: !!selectedContractorId,
        isValidContactor: !!selectedContractorId,
        isValidLocation: !!selectedContractorId,
        isValidZone: !!selectedContractorId,

        isShownDepartment: !Object.values(prevState.formHideField).includes(
          "Department",
        ),
        isShownContactor: prevState.showContractorDropdown,
        isShownLocation: prevState.showLocationDropdown,
        isShownZone: prevState.showZoneDropdown,
      };

      if (isFieldShownMapAndValid.isShownDepartment) {
        departmentError = !selectedContractorId;
      }

      if (isFieldShownMapAndValid.isShownContactor) {
        contractorError = !selectedContractorId;
      }

      if (
        isFieldShownMapAndValid.isShownLocation &&
        isFieldShownMapAndValid.isShownZone
      ) {
        locationError = !selectedContractorId;
        zoneError = !selectedContractorId;
      }

      return {
        selectedContractorId,
        departmentError,
        contractorError,
        locationError,
        zoneError,
      };
    });
    if (this.state.userData?.designation_flag != 6)
      await this._fetchClosingRightUserList();
  };

  _severityChangeHandle = async (id) => {
    if (this.state.param_list?.risk_category === true) {
      let currentDate = new Date();
      let extraHours = 0;

      if (id == 4) {
        extraHours = this.state.param_list.extreme;
      } else if (id == 3) {
        extraHours = this.state.param_list.high;
      } else if (id == 2) {
        extraHours = this.state.param_list.medium;
      } else if (id == 1) {
        extraHours = this.state.param_list.low;
      }

      // Calculate the new target date
      let newDate = new Date(
        currentDate.getTime() + extraHours * 60 * 60 * 1000,
      );

      this.setState({ selectedTargetDate: newDate });
    }
    await this.setState((prevState) => {
      let { selectedSeverity, severityError } = prevState;
      selectedSeverity = id;
      severityError = id ? false : true;
      return { selectedSeverity, severityError };
    });
  };

  _typeactChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedTypeAct, typeActError } = prevState;
      selectedTypeAct = id;
      typeActError = id ? false : true;
      return { selectedTypeAct, typeActError };
    });
  };

  _typeIncidentChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedIncidentTypeId, incidentTypeError } = prevState;
      selectedIncidentTypeId = id;
      incidentTypeError = id ? false : true;
      return { selectedIncidentTypeId, incidentTypeError };
    });
  };

  _divisionChangeHandle = async (id) => {
    await this.setState((prevState) => {
      let { selectedDivisionId, divisionError } = prevState;
      selectedDivisionId = id;
      divisionError = id ? false : true;
      return { selectedDivisionId, divisionError };
    });
    await this._fetchDepartmentList();
  };

  _evidenceFileHandle = async (event) => {
    var evidence_file = Array.from(event.target.files);
    event.target.value = "";

    const lowStorage = this.checkLowStorage();

    lowStorage
      .then(async (response) => {
        const { status, msg } = response.data;

        if (status == 200) {
          var tempUrl = [];
          var filePromise = new Promise((resolve, reject) => {
            evidence_file.forEach((item, index) => {
              let temVar;

              let reader = new FileReader();
              reader.readAsDataURL(item);
              reader.onloadend = () => {
                tempUrl.push(reader.result);
                if (index === evidence_file.length - 1) {
                  return resolve(1);
                }
              };
            });
          });

          filePromise.then(async () => {
            await this.setState((prevState) => {
              let { evidenceFileList, evidenceUrlList } = prevState;
              const tempArr = evidence_file.map((item) => item);
              evidenceFileList = [...evidenceFileList, ...tempArr];
              evidenceUrlList = [...evidenceUrlList, ...tempUrl];
              return { evidenceFileList, evidenceUrlList };
            });
          });
        }
        await this.setState({
          lowStorageStatus: status,
          lowStorageMessage: msg,
          showLowStoragePopup: status == 200 ? false : true,
        });
      })
      .catch((error) => {});
  };

  _fetchParamList = async (firstRender = false) => {
    try {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("springToken");

      let requestData = {
        auth_key: token,
        user_id: userId,
      };
      const headers = {
        "Content-Type": "application/json",
      };

      const Url =
        this.state.reportType === "nm"
          ? NM_PARAM_LIST
          : this.state.reportType === "ira"
            ? IRA_PARAM_LIST
            : UAUC_PARAM_LIST;
      const response = await Axios.get(Url, { params: requestData, headers });

      if (response.data.status === 200) {
        this._setDataLoading(false);

        const transformedData = response.data.data.reduce((acc, item) => {
          // Convert parameter to camelCase
          let camelCaseKey = item.parameter
            .toLowerCase()
            .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());

          // Assign boolean value based on `value`
          acc[camelCaseKey] = item.value === 1;

          // Handle UaUc, Ua, Uc values specifically
          if (item.parameter === "UaUc") acc["single_uauc_cost"] = item.value;
          if (item.parameter === "Ua") acc["single_ua_cost"] = item.value;
          if (item.parameter === "Uc") acc["single_uc_cost"] = item.value;
          if (item.parameter === "Risk Base Due Date") {
            acc["riskBaseDueDate"] = item.value;
            if (item.value === 1) {
              acc["manually"] = true;
            }
            if (item.value === 2) {
              acc["risk_category"] = true;
            }
            if (item.value === 3) {
              acc["mandatory"] = true;
              acc["manually"] = true;
            }
          }

          if (item.parameter === "Extreme Risk (hours)")
            acc["extreme"] = item.value;
          if (item.parameter === "High Risk (hours)") acc["high"] = item.value;
          if (item.parameter === "Medium Risk (hours)")
            acc["medium"] = item.value;
          if (item.parameter === "Low Risk (hours)") acc["low"] = item.value;
          return acc;
        }, {});

        console.log(transformedData);

        await this.setState(
          (prevState) => {
            let { param_list, dataLoading } = prevState;
            param_list = transformedData;
            dataLoading = false;
            return { param_list, dataLoading };
          },
          async () => {
            await this._fetchOptionList(firstRender);
          },
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this._setDataLoading(false);
    }
  };

  _handleChange = async (item = null, type = "observation") => {
    await this.setState((prevState) => {
      switch (type) {
        case "observation":
          let { observationText, observationError, observationURL } = prevState;
          observationText = item;
          observationError = !observationURL && !item ? true : false;
          return { observationText, observationError };
        case "control_measure":
          let { controlMeasure } = prevState;
          controlMeasure = item;
          return { controlMeasure };
        case "target_date":
          let { selectedTargetDate } = prevState;
          selectedTargetDate = item;
          return { selectedTargetDate };
        case "incident_date":
          let { selectedIncidentDate } = prevState;
          selectedIncidentDate = item;
          return { selectedIncidentDate };
        case "person_name":
          let { personName, personNameError } = prevState;
          personName = item;
          personNameError = item ? false : true;
          return { personName, personNameError };
        case "resolve_checkbox":
          let {
            resolveCheckbox,
            selectedClosingRightUserId,
            resolveError,
            closingRightUserError,
            // department, contractor & location
            departmentError,
            contractorError,
            locationError,
            zoneError,
          } = prevState;
          resolveCheckbox = item ? 1 : 0;
          selectedClosingRightUserId = item ? 0 : selectedClosingRightUserId;
          resolveError = false;
          closingRightUserError = false;
          // FOR UA/UC only Validations
          if (item) {
            departmentError = false;
            contractorError = false;
            locationError = false;
            zoneError = false;
          } else {
            const isFieldShownMapAndValid = {
              isValidDepartment: !!prevState.selectedDepartmentId,
              isValidContactor: !!prevState.selectedContractorId,
              isValidLocation: !!prevState.selectedLocationId,
              isValidZone: !!prevState.selectedZoneId,

              isShownDepartment: !Object.values(
                prevState.formHideField,
              ).includes("Department"),
              isShownContactor: prevState.showContractorDropdown,
              isShownLocation: prevState.showLocationDropdown,
              isShownZone: prevState.showZoneDropdown,
            };

            if (isFieldShownMapAndValid.isShownDepartment) {
              departmentError = !prevState.selectedDepartmentId;
            }

            if (isFieldShownMapAndValid.isShownContactor) {
              contractorError = !prevState.selectedContractorId;
            }

            if (
              isFieldShownMapAndValid.isShownLocation &&
              isFieldShownMapAndValid.isShownZone
            ) {
              locationError = !prevState.selectedLocationId;
              zoneError = !prevState.selectedZoneId;
            }
          }
          return {
            resolveCheckbox,
            selectedClosingRightUserId,
            resolveError,
            closingRightUserError,

            // department, contractor & location
            departmentError,
            contractorError,
            locationError,
            zoneError,
          };
        default:
          return prevState;
      }
    });
  };

  _removePreviewFile = async (index = 0) => {
    await this.setState((prevState) => {
      let { evidenceFileList, evidenceUrlList } = prevState;
      evidenceFileList.splice(index, 1);
      evidenceUrlList.splice(index, 1);
      return { evidenceFileList, evidenceUrlList };
    });
  };

  checkLowStorage = () => {
    return import("app/shared/utility/UtilFunction").then((utilFunction) => {
      let responseObj = utilFunction.sharedAxiosAPI(
        Url.reportSetting.checkStorage,
      );

      return responseObj;
    });
  };

  _handleLowSpace = async (statusFlag) => {
    await this.setState({ showLowStoragePopup: false });
  };

  _formValidation = async () => {
    const tempObj = this.state;

    await this.setState((prevState) => {
      prevState.observationError =
        tempObj.observationText || tempObj.observationURL ? false : true;

      if (
        (this.props.reportType === "soi" ||
          this.props.reportType === "ira" ||
          this.props.reportType === "nm") &&
        this.state.organisationSetting
      ) {
        prevState.companyError = tempObj.selectedCompanyId ? false : true;
      }

      prevState.serviceError = tempObj.selectedServiceId ? false : true;

      prevState.projectError = tempObj.selectedProjectId ? false : true;

      if (this.state.param_list.division == 1 && !tempObj.selectedDivisionId) {
        this.setState({ divisionError: true });
      }

      if (
        !Object.values(this.state.formHideField).includes("Type of Act") &&
        this.state.reportType !== "ira"
      ) {
        prevState.typeActError = tempObj.selectedTypeAct ? false : true;
      }

      if (this.state.reportType === "ira") {
        prevState.incidentTypeError = tempObj.selectedIncidentTypeId
          ? false
          : true;
      }

      prevState.activityError = tempObj.selectedActivity ? false : true;

      //

      // if report type is soi, nm & gp
      // if (this.state.reportType === "soi") {
      if (this.state.reportType === "soi" && this.state.resolveCheckbox === 0) {
        // DEPARTMENT/LOCATION/CONTRACTOR/ZONE validation START
        const isDepartmentSelected = !!tempObj.selectedDepartmentId;
        const isContractorSelected = !!tempObj.selectedContractorId;
        const isZoneLocationSelected =
          !!tempObj.selectedZoneId && !!tempObj.selectedLocationId;

        const isShownDepartment = !Object.values(
          this.state.formHideField,
        ).includes("Department");
        const isShownContactor = this.state.showContractorDropdown;
        const isShownLocation = this.state.showLocationDropdown;
        const isShownZone = this.state.showZoneDropdown;

        if (
          isDepartmentSelected ||
          isContractorSelected ||
          isZoneLocationSelected
        ) {
          prevState.departmentError = false;
          prevState.contractorError = false;
          prevState.locationError = false;
          prevState.zoneError = false;
        } else {
          prevState.departmentError = isShownDepartment
            ? !isDepartmentSelected
            : false;
          prevState.contractorError = isShownContactor
            ? !isContractorSelected
            : false;
          if (isShownLocation && isShownZone) {
            prevState.locationError = !tempObj.selectedLocationId;
            prevState.zoneError = !tempObj.selectedZoneId;
          } else {
            prevState.locationError = isShownLocation
              ? !tempObj.selectedLocationId
              : false;
            prevState.zoneError = isShownZone ? !tempObj.selectedZoneId : false;
          }
        }
      } else {
        prevState.departmentError = false;
        prevState.contractorError = false;
        prevState.locationError = false;
        prevState.zoneError = false;
      }
      // DEPARTMENT/LOCATION/CONTRACTOR/ZONE validation END

      if (
        !Object.values(this.state.formHideField).includes("Barrier") &&
        this.state.reportType === "soi"
      ) {
        prevState.barrierError = tempObj.selectedBarrier ? false : true;
      }
      if (this.state.resolveCheckbox == 0 && this.state.reportType === "soi") {
        prevState.closingRightUserError = tempObj.selectedClosingRightUserId
          ? false
          : true;
      } else {
        prevState.closingRightUserError = false;
      }
      if (
        !tempObj.selectedClosingRightUserId &&
        this.state.reportType === "soi"
      ) {
        prevState.resolveError = tempObj.resolveCheckbox ? false : true;
      } else {
        prevState.resolveError = false;
      }
      if (
        !Object.values(this.state.formHideField).includes("Hazard") &&
        this.state.reportType != "ira"
      ) {
        prevState.hazardError = tempObj.selectedHazardId ? false : true;
      }

      if (
        this.state.param_list?.subActivity &&
        this.state.subActivityList.length > 0
      ) {
        prevState.subActivityError = tempObj.selectedSubActivity ? false : true;
      } else {
        prevState.subActivityError = false;
      }

      if (
        (this.state.reportType == "soi" || this.state.reportType == "nm") &&
        this.state.param_list?.subHazard &&
        this.state.subHazardList.length > 0
      ) {
        prevState.subHazardError = tempObj.selectedSubHazardId ? false : true;
      } else {
        prevState.subHazardError = false;
      }

      if (this.state.reportType == "soi" || this.state.reportType == "nm") {
        prevState.severityError = tempObj.selectedSeverity ? false : true;
      } else {
        prevState.severityError = false;
      }

      return prevState;
    });
  };

  _uploadFile = async (file) => {
    if (file != null) {
      await this.setState((prevState) => {
        let { selectedFile, tempFiles } = prevState;
        selectedFile = file;
        tempFiles = [...tempFiles, file];
        return { selectedFile, tempFiles };
      });
    }
  };

  _removeUploadedFile = async (removedFile) => {
    console.log("Removing file from parent:", removedFile.name);

    await this.setState((prevState) => {
      let { tempFiles } = prevState;

      // Find and remove the file from tempFiles array
      const updatedFiles = tempFiles.filter((existingFile) => {
        // Compare multiple properties to ensure correct file identification
        return !(
          existingFile.name === removedFile.name &&
          existingFile.size === removedFile.size &&
          existingFile.type === removedFile.type &&
          existingFile.lastModified === removedFile.lastModified
        );
      });

      return { tempFiles: updatedFiles };
    });

    console.log("Updated tempFiles count:", this.state.tempFiles.length);
  };

  _submitSOI = async () => {
    await this._formValidation();

    // Checking form have any Error
    let formErrorStatus;
    for (var propertyName in this.state) {
      if (propertyName.includes("Error")) {
        if (this.state[propertyName]) {
          console.log(propertyName);
          formErrorStatus = true;
          return;
        } else {
          formErrorStatus = false;
        }
      }
    }

    // If form not have error then submit form
    if (!formErrorStatus) {
      // this.props.parentStateSetter(({
      //   apiLoading:true
      // }));
      if (this.state.reportType == "ira") {
        if (this.state.voilatorId !== "" && this.state.personName === "") {
          ErrorToast(this.props.t("pleaseEnterTheInjuredEmployeeName"));
          return false;
        } else if (
          this.state.voilatorId === "" &&
          this.state.personName !== ""
        ) {
          ErrorToast(this.props.t("pleaseEnterTheInjuredPersonID"));

          return false;
        }
      }

      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("springToken");

      // Check for Mandatory Evidence
      if (
        this.state.param_list?.reportEvidenceMandotory &&
        this.state.tempFiles.length === 0
      ) {
        ErrorToast("Please attach evidence");
        return;
      }

      await this.setState({ dataLoading: true });

      this._setDataLoading(true);

      let soiData = new FormData();
      let targetDate;
      let incidentDate;

      soiData.append("auth_key", token);
      soiData.append("user_id", userId);

      soiData.append(
        "companyId",
        this.state.selectedCompanyId ? this.state.selectedCompanyId : 0,
      );

      soiData.append(
        "serviceId",
        this.state.selectedServiceId ? this.state.selectedServiceId : 0,
      );
      soiData.append(
        "projectId",
        this.state.selectedProjectId ? this.state.selectedProjectId : 0,
      );
      soiData.append(
        "typeOfAct",
        this.state.selectedTypeAct ? this.state.selectedTypeAct : 0,
      );

      if (this.state.reportType !== "ira") {
        soiData.append(
          "severity",
          this.state.selectedSeverity ? this.state.selectedSeverity : 0,
        );
      } else {
        soiData.append(
          "severityValue",
          this.state.selectedSeverity ? this.state.selectedSeverity : 0,
        );
      }

      soiData.append(
        "activityId",
        this.state.selectedActivity ? this.state.selectedActivity : 0,
      );
      // Send sub-activity if Risk Register mode is ON or parameter is enabled
      if (this.state.param_list?.subActivity) {
        soiData.append(
          "subActivity",
          this.state.selectedSubActivity ? this.state.selectedSubActivity : 0,
        );
      }
      if (this._isRiskRegisterMode()) {
        soiData.append(
          "projectCategory",
          this.state.projectAutoFill.projectCategoryId || "",
        );
        soiData.append("region", this.state.projectAutoFill.region || "");
        soiData.append("state", this.state.projectAutoFill.state || "");
        soiData.append("city", this.state.projectAutoFill.city || "");
      }
      let hazardIdToSend = this.state.selectedHazardId
        ? this.state.selectedHazardId
        : 0;
      let subHazardIdToSend = this.state.selectedSubHazardId
        ? this.state.selectedSubHazardId
        : 0;
      if (this._isRiskRegisterMode()) {
        const hazardNode = this._currentRrHazards().find(
          (h) => h.hazardId == this.state.selectedHazardId,
        );
        if (hazardNode) {
          hazardIdToSend = hazardNode.oldHazardId ?? hazardIdToSend;
          const subHazardNode = (hazardNode.subHazards || []).find(
            (sh) => sh.subHazardId == this.state.selectedSubHazardId,
          );
          if (subHazardNode) {
            subHazardIdToSend =
              subHazardNode.oldSubHazardId ?? subHazardIdToSend;
          }
        }
      }
      soiData.append("hazardId", hazardIdToSend);

      let controlMeasureIds =
        this.state.selectedControlMeasureIds?.map((data) => data.id) || [];
      soiData.append("controlMeasureId", controlMeasureIds);
      // soiData.append("controlMeasureId", ["616"]);

      const {
        selectedZoneId,
        selectedLocationId,
        selectedDepartmentId,
        selectedContractorId,
      } = this.state;

      // validation
      const isDepartmentSelected = !!selectedDepartmentId;
      const isContractorSelected = !!selectedContractorId;
      const isZoneLocationSelected = !!selectedZoneId && !!selectedLocationId;

      if (
        !isDepartmentSelected &&
        !isContractorSelected &&
        !isZoneLocationSelected
      ) {
        await this.setState({ dataLoading: false });
        ErrorToast(
          "Please select either Department or Contractor or both Zone and Location",
        );
        return;
      }

      soiData.append(
        "zoneId",
        this.state.selectedZoneId ? this.state.selectedZoneId : 0,
      );
      soiData.append(
        "locationId",
        this.state.selectedLocationId ? this.state.selectedLocationId : 0,
      );
      soiData.append(
        "departmentId",
        this.state.selectedDepartmentId ? this.state.selectedDepartmentId : 0,
      );
      soiData.append(
        "contractorId",
        this.state.selectedContractorId ? this.state.selectedContractorId : 0,
      );
      soiData.append(
        "divisionId",
        this.state.selectedDivisionId ? this.state.selectedDivisionId : 0,
      );

      if (this.state.selectedTargetDate) {
        let targetDate = convertDateToUTC(this.state.selectedTargetDate);
        soiData.append("riskBaseDueDate", targetDate || null);
      } else if (
        !this.state.selectedTargetDate &&
        this.state.param_list?.riskBaseDueDate === 3
      ) {
        this.setState({ targetDateError: true, dataLoading: false });
        this._setDataLoading(false);
        return;
      }
      // soiData.append(
      //   "activeUserId",
      //   this.state.activeUser ? this.state.activeUser.value : null
      // );

      if (this.state.reportType === "soi") {
        soiData.append(
          "closingRightUserId",
          this.state.selectedClosingRightUserId
            ? this.state.selectedClosingRightUserId
            : 0,
        );
        if (this.state.sourceId !== null) {
          soiData.append("source", this.state.sourceId);
        }

        if (this.state.param_list?.previousDate) {
          const selectedDate = formatLocalDate(
            this.state.selectedDate,
            "YYYY-MM-DD",
          );
          soiData.append("previousDate", selectedDate);
        } else {
          soiData.append("previousDate", "");
        }
      }
      soiData.append(
        "observation",
        this.state.observationText ? this.state.observationText : "",
      );

      let incidentPersons = [];

      if (this.state.searchFiledUsers.length) {
        const searchFiledUsersData = this.state.searchFiledUsers.map((el) => ({
          incidentPersonId: el.employeeId,
          searchIncidentPersonId: el.incident_person_id,
          incidentPersonName: el?.incident_person_name,
        }));

        incidentPersons = [...incidentPersons, ...searchFiledUsersData];
      }

      if (this.state.searchEmployeeUsers.length) {
        const searchFiledUsersData = this.state.searchEmployeeUsers.map(
          (el) => ({
            incidentPersonId: el?.clientEmployeeId,
            searchIncidentPersonId: el?.id,
            incidentPersonName: el?.displayName,
          }),
        );

        incidentPersons = [...incidentPersons, ...searchFiledUsersData];
      }

      if (
        this.state.voilatorIdList.length &&
        this.state.voilatorPersonList.length
      ) {
        const violatorData = this.state.voilatorIdList.map((id, index) => ({
          incidentPersonId: id,
          incidentPersonName: this.state.voilatorPersonList[index] || "",
          searchIncidentPersonId: 0,
        }));

        incidentPersons = [...incidentPersons, ...violatorData];
      }
      let tempPersonList = [...this.state.personNameList];

      if (tempPersonList.length) {
        const violatorData = tempPersonList.map((id, index) => ({
          incidentPersonId: this.state.voilatorIdList[index] || "",
          incidentPersonName: id || "",
          searchIncidentPersonId: 0,
        }));

        incidentPersons = [...incidentPersons, ...violatorData];
      }

      soiData.append("incidentPersonString", JSON.stringify(incidentPersons));

      if (this.state.reportType === "soi") {
        const { voilatorPersonList } = this.state;
        // voilatorPersonList.forEach((el) => {
        //   soiData.append("incident_person_name", el);
        // });
        if (!Object.values(this.state.formHideField).includes("Target Date")) {
          targetDate = convertDateToUTC(this.state.selectedTargetDate);
        } else {
          targetDate = "";
        }

        soiData.append("targetDate", targetDate);
        soiData.append(
          "controlMeasure",
          this.state.controlMeasure ? this.state.controlMeasure : "",
        );
        soiData.append("selfClosing", this.state.resolveCheckbox ? 1 : 0);
        soiData.append("subHazardId", subHazardIdToSend);
        soiData.append(
          "barrierId",
          this.state.selectedBarrier ? this.state.selectedBarrier : 0,
        );
        // if (this.state.searchEmployeeUsers) {
        //   soiData.append("employeeMasterId", this.state.searchEmployeeUsers.id || 0);
        // }
      }
      if (this.state.reportType === "nm") {
        soiData.append("subHazardId", subHazardIdToSend);
      }

      soiData.append("lat", this.state.lat);
      soiData.append("lang", this.state.long);

      if (this.state.reportType === "soi") {
        soiData.append("observation_file", this.state.observationAudio);
      }

      if (this.state.reportType === "nm" || this.state.reportType === "ira") {
        soiData.append("observationRecord", this.state.observationAudio);
      }

      // UAUC report only have Control measure
      // if (this.state.reportType === "soi") {
      //   soiData.append("control_measure_file", this.state.controlMeasureAudio);
      // }

      if (this.state.reportType === "nm") {
        if (
          !Object.values(this.state.formHideField).includes("Incident Date")
        ) {
          incidentDate = convertDateToUTC(
            this.state.selectedIncidentDate,
            "YYYY-MM-DD",
          );
        } else {
          incidentDate = "";
        }

        if (tempPersonList.length) {
          tempPersonList.map((personItem) => {
            soiData.append("incident_person_name", personItem);
          });
        }

        soiData.append("incidentTime", this.state.selectedIncidentTime);
        soiData.append("incidentDate", incidentDate);
      }

      if (this.state.reportType === "ira") {
        if (
          !Object.values(this.state.formHideField).includes("Incident Date")
        ) {
          incidentDate = convertDateToUTC(
            this.state.selectedIncidentDate,
            "YYYY-MM-DD",
          );
        } else {
          incidentDate = "";
        }
        soiData.append("incidentTime", this.state.selectedIncidentTime);
        soiData.append("incidentDate", incidentDate);
        if (this.state.observationAudio) {
          soiData.append("observationFile", this.state.observationAudio);
        }
        if (this.state.iraId) {
          soiData.append("iraId", this.state.iraId);
        }
      }

      // Evidence File
      if (this.state.tempFiles.length) {
        this.state.tempFiles.forEach((el) => {
          soiData.append("file", el || "");
        });
      }

      soiData.append("fileStatus", this.state.selectedFile ? 1 : 0);

      var ContentType = {
        "Content-Type": "multipart/form-data",
      };

      let URL = Url.createReport.soiReport;
      switch (this.state.reportType) {
        case "nm":
          URL = Url.createReport.springnmReport;
          break;
        case "ira":
          URL = Url.createReport.springIraReport;
          break;
        default:
          URL = Url.createReport.uaucReport;
          break;
      }

      // Display the key/value pairs
      for (var pair of soiData.entries()) {
        console.log("soiData here", pair[0] + ", " + pair[1]);
      }

      const formObject = Object.fromEntries(soiData.entries());

      console.log("soiData", JSON.stringify(formObject, null, 2));
      console.log("URL", URL);
      //console.log("ContentType", ContentType);
      //return;
      await axios
        .post(URL, soiData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            auth_key: token,
            user_id: userId,
          },
        })
        .then(async (response) => {
          this.setState({
            clearDropZone: true,
          });
          this._setDataLoading(false);
          if (response.data.status === 200) {
            SuccessToast(
              response?.data?.msg || "Report submitted successfully!",
            );
            await this._continueReportingClearForm();

            await this.setState({
              reportNumber: response?.data?.data?.reportNumber,
              sucesssPopup: true,
              selectedFile: null,
              clearDropZone: true,
            });

            if (this.state.isCheckboxChecked) {
              await this.setState({
                showResolveModal: true,
                reportId: response.data.data.reportId,
              });
            }
          } else {
            if (response.data.status !== 200) {
              ErrorToast(response.data?.msg || "Something went wrong!");
            }
            await this._continueReportingClearForm();
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
          ErrorToast(error.response.data?.msg || "Something went wrong!");
        });
      // .finally(() =>{
      //   this.props.parentStateSetter(({
      //     apiLoading:false
      //   }));
      // })
    }
  };

  _submitSOIIra = async () => {
    await this._formValidation();

    // Checking form have any Error
    let formErrorStatus;
    for (var propertyName in this.state) {
      if (propertyName.includes("Error")) {
        if (this.state[propertyName]) {
          console.log(propertyName);
          formErrorStatus = true;
          return;
        } else {
          formErrorStatus = false;
        }
      }
    }

    // If form not have error then submit form
    if (!formErrorStatus) {
      // this.props.parentStateSetter(({
      //   apiLoading:true
      // }));
      if (this.state.reportType == "ira") {
        if (this.state.voilatorId !== "" && this.state.personName === "") {
          ErrorToast(this.props.t("pleaseEnterTheInjuredEmployeeName"));
          return false;
        } else if (
          this.state.voilatorId === "" &&
          this.state.personName !== ""
        ) {
          ErrorToast(this.props.t("pleaseEnterTheInjuredPersonID"));

          return false;
        }
      }

      const {
        selectedZoneId,
        selectedLocationId,
        selectedDepartmentId,
        selectedContractorId,
      } = this.state;

      const isDepartmentSelected = !!selectedDepartmentId;
      const isContractorSelected = !!selectedContractorId;
      const isZoneLocationSelected = !!selectedZoneId && !!selectedLocationId;

      if (
        !isDepartmentSelected &&
        !isContractorSelected &&
        !isZoneLocationSelected
      ) {
        await this.setState({ dataLoading: false });
        ErrorToast(
          "Please select either Department or Contractor or both Zone and Location",
        );
        return false;
      }

      const userId = localStorage.getItem("userId");
      const springToken = localStorage.getItem("springToken");
      const token = localStorage.getItem("token");
      const tokenToUse =
        this.state.reportType === "ira" ? springToken || token : token;

      await this.setState({ dataLoading: true });

      this._setDataLoading(true);

      let soiData = new FormData();
      let targetDate;
      let incidentDate;

      soiData.append("auth_key", tokenToUse);
      soiData.append("user_id", userId);
      soiData.append(
        "companyId",
        this.state.selectedCompanyId ? this.state.selectedCompanyId : 0,
      );
      if (this.state.reportType === "ira") {
        soiData.append(
          "serviceId",
          this.state.selectedServiceId ? this.state.selectedServiceId : 0,
        );
        soiData.append(
          "projectId",
          this.state.selectedProjectId ? this.state.selectedProjectId : 0,
        );
        soiData.append(
          "typeOfAct",
          this.state.selectedTypeAct ? this.state.selectedTypeAct : 0,
        );
        // soiData.append(
        //   "severityValue",
        //   this.state.selectedSeverity ? this.state.selectedSeverity : 0,
        // );
        soiData.append(
          "activityId",
          this.state.selectedActivity ? this.state.selectedActivity : 0,
        );
        soiData.append(
          "subActivity",
          this.state.selectedSubActivity ? this.state.selectedSubActivity : 0,
        );
        soiData.append(
          "severityValue",
          this.state.selectedIncidentTypeId
            ? this.state.selectedIncidentTypeId
            : 0,
        );
        if (this.state.projectAutoFill) {
          soiData.append(
            "projectCategory",
            this.state.projectAutoFill.projectCategoryId || "",
          );
          soiData.append("region", this.state.projectAutoFill.region || "");
          soiData.append("state", this.state.projectAutoFill.state || "");
          soiData.append("city", this.state.projectAutoFill.city || "");
        }
        soiData.append(
          "hazardId",
          this.state.selectedHazardId ? this.state.selectedHazardId : 0,
        );
        let controlMeasureIds =
          this.state.selectedControlMeasureIds?.map((data) => data.id) || [];
        soiData.append("controlMeasureId", controlMeasureIds);
        soiData.append(
          "zoneId",
          this.state.selectedZoneId ? this.state.selectedZoneId : 0,
        );
        soiData.append(
          "locationId",
          this.state.selectedLocationId ? this.state.selectedLocationId : 0,
        );
        soiData.append(
          "departmentId",
          this.state.selectedDepartmentId ? this.state.selectedDepartmentId : 0,
        );
        soiData.append(
          "contractorId",
          this.state.selectedContractorId ? this.state.selectedContractorId : 0,
        );
      } else {
        soiData.append(
          "service_id",
          this.state.selectedServiceId ? this.state.selectedServiceId : 0,
        );
        soiData.append(
          "project_id",
          this.state.selectedProjectId ? this.state.selectedProjectId : 0,
        );
        soiData.append(
          "type_of_act",
          this.state.selectedTypeAct ? this.state.selectedTypeAct : 0,
        );
        soiData.append(
          "severity",
          this.state.selectedSeverity ? this.state.selectedSeverity : 0,
        );
        soiData.append(
          "activity_id",
          this.state.selectedActivity ? this.state.selectedActivity : 0,
        );
        soiData.append(
          "hazard_id",
          this.state.selectedHazardId ? this.state.selectedHazardId : 0,
        );
        this.state.selectedControlMeasureIds.forEach((data) => {
          soiData.append("control_measure_id", data.id);
        });
        soiData.append(
          "zone_id",
          this.state.selectedZoneId ? this.state.selectedZoneId : 0,
        );
        soiData.append(
          "location_id",
          this.state.selectedLocationId ? this.state.selectedLocationId : 0,
        );
        soiData.append(
          "department_id",
          this.state.selectedDepartmentId ? this.state.selectedDepartmentId : 0,
        );
        soiData.append(
          "contractor_id",
          this.state.selectedContractorId ? this.state.selectedContractorId : 0,
        );
      }
      if (this.state.reportType === "soi") {
        soiData.append(
          "closing_right_user_id",
          this.state.selectedClosingRightUserId
            ? this.state.selectedClosingRightUserId
            : 0,
        );
        if (this.state.sourceId !== null) {
          soiData.append("source", this.state.sourceId);
        }
      }
      soiData.append(
        "observation",
        this.state.observationText ? this.state.observationText : "",
      );
      if (this.state.searchFiledUsers.length) {
        this.state.searchFiledUsers.forEach((el) => {
          soiData.append("incident_person_id", el.employeeId);
          soiData.append("searched_incident_person_id", el.incident_person_id);
          soiData.append("incident_person_name", el?.incident_person_name);
        });
      }
      if (this.state.voilatorIdList.length) {
        this.state.voilatorIdList.forEach((el) => {
          soiData.append("incident_person_id", el);
        });
      }
      if (this.state.reportType === "soi") {
        const { voilatorPersonList } = this.state;
        voilatorPersonList.forEach((el) => {
          soiData.append("incident_person_name", el);
        });
        if (!Object.values(this.state.formHideField).includes("Target Date")) {
          targetDate = formatLocalDate(
            this.state.selectedTargetDate,
            "YYYY-MM-DD",
          );
        } else {
          targetDate = "";
        }

        soiData.append("target_date", targetDate);
        soiData.append(
          "control_measure",
          this.state.controlMeasure ? this.state.controlMeasure : "",
        );
        soiData.append("self_closing", this.state.resolveCheckbox ? 1 : 0);
        soiData.append(
          "sub_hazard_id",
          this.state.selectedSubHazardId ? this.state.selectedSubHazardId : 0,
        );
        soiData.append(
          "barrier_id",
          this.state.selectedBarrier ? this.state.selectedBarrier : 0,
        );
      }
      if (this.state.reportType === "nm") {
        soiData.append(
          "sub_hazard_id",
          this.state.selectedSubHazardId ? this.state.selectedSubHazardId : 0,
        );
      }

      soiData.append("lat", this.state.lat);
      soiData.append("lang", this.state.long);

      if (this.state.reportType === "soi") {
        soiData.append("observation_file", this.state.observationAudio);
      }

      if (this.state.reportType === "nm" || this.state.reportType === "ira") {
        soiData.append("observation_record", this.state.observationAudio);
      }

      // UAUC report only have Control measure
      if (this.state.reportType === "soi") {
        soiData.append("control_measure_file", this.state.controlMeasureAudio);
      }

      if (this.state.reportType === "nm") {
        if (
          !Object.values(this.state.formHideField).includes("Incident Date")
        ) {
          incidentDate = convertDateToUTC(this.state.selectedIncidentDate);
        } else {
          incidentDate = "";
        }

        let tempPersonList = [...this.state.personNameList];
        if (tempPersonList.length) {
          tempPersonList.map((personItem) => {
            soiData.append("incident_person_name", personItem);
          });
        } else {
          soiData.append("incident_person_name", "");
        }

        soiData.append("incident_time", this.state.selectedIncidentTime);
        soiData.append("incident_date", incidentDate);
      }

      if (this.state.reportType === "ira") {
        if (
          !Object.values(this.state.formHideField).includes("Incident Date")
        ) {
          incidentDate = convertDateToUTC(
            this.state.selectedIncidentDate,
            "YYYY-MM-DD",
          );
        } else {
          incidentDate = "";
        }
        soiData.append("incidentTime", this.state.selectedIncidentTime);
        soiData.append("incidentDate", incidentDate);
        if (this.state.observationAudio) {
          soiData.append("observationFile", this.state.observationAudio);
        }
        if (this.state.iraId) {
          soiData.append("iraId", this.state.iraId);
        }

        let incidentPersons = [];

        if (this.state.searchFiledUsers.length) {
          const searchFiledUsersData = this.state.searchFiledUsers.map(
            (el) => ({
              incidentPersonId: el.employeeId,
              searchIncidentPersonId: el.incident_person_id,
              incidentPersonName: el?.incident_person_name,
            }),
          );

          incidentPersons = [...incidentPersons, ...searchFiledUsersData];
        }

        if (this.state.searchEmployeeUsers.length) {
          const searchFiledUsersData = this.state.searchEmployeeUsers.map(
            (el) => ({
              incidentPersonId: el?.clientEmployeeId,
              searchIncidentPersonId: el?.id,
              incidentPersonName: el?.displayName,
            }),
          );

          incidentPersons = [...incidentPersons, ...searchFiledUsersData];
        }

        if (
          this.state.voilatorIdList.length &&
          this.state.voilatorPersonList.length
        ) {
          const violatorData = this.state.voilatorIdList.map((id, index) => ({
            incidentPersonId: id,
            incidentPersonName: this.state.voilatorPersonList[index] || "",
            searchIncidentPersonId: 0,
          }));

          incidentPersons = [...incidentPersons, ...violatorData];
        }

        let tempPersonList = [...this.state.personNameList];

        if (tempPersonList.length) {
          const violatorData = tempPersonList.map((id, index) => ({
            incidentPersonId: this.state.voilatorIdList[index] || "",
            incidentPersonName: id || "",
            searchIncidentPersonId: 0,
          }));

          incidentPersons = [...incidentPersons, ...violatorData];
        }

        soiData.append("incidentPersonString", JSON.stringify(incidentPersons));
      }

      // Evidence File
      if (this.state.tempFiles.length) {
        this.state.tempFiles.forEach((el) => {
          soiData.append("file", el || "");
        });
      }

      if (this.state.reportType === "ira") {
        soiData.append("fileStatus", this.state.selectedFile ? 1 : 0);
      } else {
        soiData.append("file_status", this.state.selectedFile ? 1 : 0);
      }

      let URL = Url.createReport.soiReport;
      switch (this.state.reportType) {
        case "nm":
          URL = Url.createReport.nmReport;
          break;
        case "ira":
          URL = Url.createReport.iraReport;
          break;
        default:
          URL = Url.createReport.soiReport;
          break;
      }

      const axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (this.state.reportType === "ira") {
        axiosConfig.params = {
          auth_key: tokenToUse,
          user_id: userId,
        };
      }

      await axios
        .post(URL, soiData, axiosConfig)
        .then(async (response) => {
          this.setState({
            clearDropZone: true,
          });
          this._setDataLoading(false);
          if (response.data.status === 200) {
            await this._continueReportingClearForm();
            await this.setState({
              reportNumber:
                response.data?.data?.reportNumber ||
                response.data?.report_number,
              sucesssPopup: true,
              selectedFile: null,
            });
            if (this.state.isCheckboxChecked) {
              await this.setState({
                showResolveModal: true,
                reportId:
                  response.data?.data?.reportId || response.data?.report_id,
              });
            }
          } else {
            if (response.data.status !== 200) {
              ErrorToast(response.data?.msg);
            }
            await this._continueReportingClearForm();
          }
        })
        .catch((error) => {
          this._setDataLoading(false);
        });
      // .finally(() =>{
      //   this.props.parentStateSetter(({
      //     apiLoading:false
      //   }));
      // })
    }
  };

  _showRecorder = async (flag = false, type = "observation") => {
    if (flag) {
      const lowStorage = this.checkLowStorage();
      lowStorage
        .then(async (response) => {
          const { status, msg } = response.data;

          if (status == 200) {
            await this.setState((prevState) => {
              let { showRecorderModal, recordingFor } = prevState;
              showRecorderModal = flag;
              recordingFor = type;
              return { showRecorderModal, recordingFor };
            });
          }
          await this.setState({
            lowStorageStatus: status,
            lowStorageMessage: msg,
            showLowStoragePopup: status == 200 ? false : true,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await this.setState((prevState) => {
        let { showRecorderModal, recordingFor } = prevState;
        showRecorderModal = flag;
        recordingFor = type;
        return { showRecorderModal, recordingFor };
      });
    }
  };

  startRecording = async () => {
    await this.setState({ recordAudio: true });
  };

  stopRecording = async () => {
    await this.setState({ recordAudio: false });
  };

  onStop = async (recordedBlob) => {
    let promise = new Promise((resolve, error) => {
      let reader = new FileReader();
      reader.readAsDataURL(recordedBlob.blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });

    promise.then(async (response) => {
      await this.setState((prevState) => {
        let {
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
        } = prevState;
        if (this.state.recordingFor === "control_measure") {
          controlMeasureAudio = recordedBlob.blob;
          controlMeasureURL = response;
        }
        if (this.state.recordingFor === "observation") {
          observationAudio = recordedBlob.blob;
          observationURL = response;

          console.log(observationURL, observationAudio);
        }
        return {
          controlMeasureAudio,
          controlMeasureURL,
          observationAudio,
          observationURL,
        };
      });
    });
  };

  _setDataLoading = async (status) => {
    await this.setState((prevState) => {
      let { dataLoading } = prevState;
      dataLoading = status;
      return { dataLoading };
    });
  };

  _removeAudioFile = async (type) => {
    await this.setState((prevState) => {
      if (type === "observation") {
        prevState.observationAudio = "";
        prevState.observationURL = "";
        return prevState;
      }

      if (type === "control_measure") {
        prevState.controlMeasureAudio = "";
        prevState.controlMeasureURL = "";
        return prevState;
      }
    });
  };

  _onTimeChange = async (options) => {
    const { hour, minute, meridiem } = options;

    const time = `${hour}:${minute}:00 ${meridiem}`;
    const formattedTime = moment(time, ["h:mm A"]).format("HH:mm");

    await this.setState({
      selectedIncidentTime: formattedTime,
      selectedTimeMeridiem: meridiem,
    });
  };

  _reportType = () => {
    if (this.state.reportType == "nm") {
      return "NM";
    } else if (this.state.reportType == "ira") {
      return "IRA";
    } else {
      return "UA/UC";
    }
  };

  _clearForm = async () => {
    await this.setState((prevState) => {
      prevState.selectedSubActivity = null;
      prevState.subActivityList = [];
      prevState.subActivityError = false;
      prevState.typeActList = TYPE_ACT;
      prevState.typeIncidentList = INCIDENT_TYPE;
      prevState.severityList =
        this.props.reportType === "nm" ? SEVERITY : SEVERITYOPTION;
      prevState.projectList = [];
      prevState.departmentList = [];
      prevState.contractorList = [];
      prevState.zoneList = [];
      prevState.locationList = [];
      prevState.closingRightUserList = [];
      prevState.hazardList = [];
      prevState.activityList = [];
      prevState.barrierList = [];
      prevState.subHazardList = [];
      prevState.controlMeasureList = [];
      prevState.tempFiles = []; // Ensure this is included
      prevState.clearDropZone = false;
      prevState.observationText = "";
      prevState.evidenceFileList = [];
      prevState.evidenceUrlList = [];
      prevState.selectedCompanyId = null;
      prevState.selectedServiceId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedServiceId
          : null;
      prevState.selectedProjectId =
        this.state.userData.designation_flag === 4
          ? prevState.selectedProjectId
          : null;
      prevState.selectedDepartmentId = null;
      prevState.selectedContractorId = null;
      prevState.selectedZoneId = null;
      prevState.selectedLocationId = null;
      prevState.selectedClosingRightUserId = null;
      prevState.selectedTypeAct = null;
      prevState.selectedActivity = null;
      prevState.selectedSeverity = null;
      prevState.selectedBarrier = null;
      prevState.selectedHazardId = null;
      prevState.selectedSubHazardId = null;

      prevState.selectedControlMeasureIds = [];
      prevState.selectedIncidentTypeId = 0;

      prevState.selectedTargetDate = new Date();
      prevState.controlMeasure = "";
      prevState.resolveCheckbox = false;
      prevState.soiFormHidingField = {};
      prevState.nmFormHidingField = {};
      prevState.iraFormHidingField = {};

      prevState.serviceError = false;
      prevState.projectError = false;

      prevState.zoneError = false;
      prevState.departmentError = false;
      prevState.contractorError = false;
      prevState.locationError = false;
      prevState.closingRightUserError = false;
      prevState.resolveError = false;

      prevState.typeActError = false;
      prevState.activityError = false;
      prevState.severityError = false;
      prevState.incidentTypeError = false;
      prevState.barrierError = false;
      prevState.hazardError = false;
      prevState.observationError = false;
      prevState.controlMeasureError = false;

      prevState.showRecorderModal = false;
      prevState.recordAudio = false;
      prevState.controlMeasureAudio = "";
      prevState.controlMeasureURL = "";
      prevState.observationAudio = "";
      prevState.observationURL = "";
      prevState.recordingFor = "observation";

      prevState.selectedIncidentTime = "10:00";
      prevState.selectedIncidentDate = new Date();
      prevState.selectedTimeMeridiem = "AM";
      prevState.personName = "";
      prevState.incidentPersonNameError = false;
      prevState.voilatorId = "";
      prevState.voilatorPersonName = "";
      prevState.projectAutoFill = {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      };

      return prevState;
    });
  };

  _continueReportingClearForm = async () => {
    await this.setState((prevState) => {
      prevState.selectedSubActivity = null;
      prevState.subActivityList = [];
      prevState.subActivityError = false;
      prevState.typeActList = TYPE_ACT;
      prevState.typeIncidentList = INCIDENT_TYPE;
      prevState.severityList =
        this.props.reportType === "nm" ? SEVERITY : SEVERITYOPTION;

      prevState.observationText = "";
      prevState.evidenceFileList = [];
      prevState.evidenceUrlList = [];
      prevState.selectedServiceId = null;
      prevState.selectedCompanyId = null;
      prevState.selectedProjectId = null;
      prevState.selectedDepartmentId = null;
      prevState.selectedContractorId = null;
      prevState.selectedZoneId = null;
      prevState.selectedLocationId = null;
      prevState.selectedDivisionId = null;
      prevState.selectedClosingRightUserId = null;
      prevState.selectedTypeAct = null;
      prevState.selectedActivity = null;
      prevState.selectedSeverity = null;
      prevState.selectedBarrier = null;
      prevState.selectedHazardId = null;
      prevState.selectedSubHazardId = null;
      prevState.selectedControlMeasureIds = [];
      prevState.selectedIncidentTypeId = 0;
      prevState.sourceId = null;
      prevState.selectedTargetDate = new Date();
      prevState.controlMeasure = "";
      prevState.resolveCheckbox = false;
      prevState.soiFormHidingField = {};
      prevState.nmFormHidingField = {};
      prevState.iraFormHidingField = {};
      prevState.voilatorId = "";
      prevState.voilatorPersonName = "";
      prevState.voilatorPersonList = [];
      prevState.voilatorIdList = [];
      prevState.tempFiles = [];
      prevState.serviceError = false;
      prevState.projectError = false;
      prevState.clearDropZone = true;
      prevState.zoneError = false;
      prevState.departmentError = false;
      prevState.contractorError = false;
      prevState.locationError = false;
      prevState.closingRightUserError = false;
      prevState.resolveError = false;

      prevState.typeActError = false;
      prevState.activityError = false;
      prevState.severityError = false;
      prevState.incidentTypeError = false;
      prevState.barrierError = false;
      prevState.hazardError = false;
      prevState.observationError = false;

      prevState.showRecorderModal = false;
      prevState.recordAudio = false;
      prevState.controlMeasureAudio = "";
      prevState.controlMeasureURL = "";
      prevState.observationAudio = "";
      prevState.observationURL = "";
      prevState.recordingFor = "observation";

      prevState.selectedIncidentTime = "10:00";
      prevState.selectedIncidentDate = new Date();
      prevState.selectedTimeMeridiem = "AM";
      prevState.personName = "";

      prevState.incidentPersonNameError = false;

      // clearing dropdown values
      prevState.serviceList = [];
      prevState.projectList = [];
      prevState.departmentList = [];
      prevState.divisionList = [];
      prevState.contractorList = [];
      prevState.zoneList = [];
      prevState.ocationList = [];
      prevState.closingRightUserList = [];
      prevState.barrierList = [];
      prevState.hazardList = [];
      prevState.subHazardList = [];
      prevState.activityList = [];
      prevState.personNameList = [];
      prevState.typeActList = [];
      prevState.typeIncidentList = [];
      prevState.severityList = [];
      prevState.locationList = [];
      prevState.controlMeasureList = [];

      prevState.resolveCheckbox = 0;
      prevState.selectedFile = null;

      prevState.projectAutoFill = {
        projectCategory: "",
        projectCategoryId: "",
        region: "",
        state: "",
        city: "",
      };

      return prevState;
    });

    if (this.state.organisationSetting) {
      await this._fetchCompanyList();
    } else {
      await this._fetchServiceList();
    }
  };

  _addPersonName = async () => {
    if (this.state.personName) {
      await this.setState((prevState) => {
        let { personName, personNameList, incidentPersonNameError } = prevState;
        personNameList = [...personNameList, personName];
        personName = "";
        incidentPersonNameError = false;
        return { personName, personNameList, incidentPersonNameError };
      });
    } else {
      ErrorToast(this.props.t("enterValidInjuredEmployeeName"));
    }
  };

  _removePersonName = async (position) => {
    await this.setState((prevState) => {
      let { personNameList } = prevState;
      personNameList.splice(position, 1);
      return { personNameList };
    });
  };

  _getDynamicAboutLabel = () => {
    switch (this.state.reportType) {
      case "nm":
        return this.props.t("nmDetails");
      case "soi":
        return this.props.t("uaucDetails");
      case "ira":
        return this.props.t("incidentDetails");
      case "gp":
        return this.props.t("goodPracticesDetails");
      default:
        return this.props.t("uaucDetails");
    }
  };

  _getDynamicPersonNameLabel = () => {
    switch (this.state.reportType) {
      case "nm":
        return this.props.t("involvedPersonName");
      case "ira":
        return this.props.t("injuredEmployeeName");
      default:
        return this.props.t("employeeName");
    }
  };
  _manageVoilatorState = (val, type) => {
    const { voilatorIdList, voilatorPersonList } = this.state;
    const temp = Array.from(type === 2 ? voilatorIdList : voilatorPersonList);
    temp.push(val);
    this.setState({
      [type === 2 ? "voilatorIdList" : "voilatorPersonList"]: temp,
      [type === 2 ? "voilatorId" : "voilatorPersonName"]: "",
    });
  };

  removeVoilator = (voilatorId, type = 1) => {
    const { voilatorIdList, voilatorPersonList } = this.state;
    const temp = [
      ...Array.from(type === 2 ? voilatorIdList : voilatorPersonList),
    ];
    temp.splice(voilatorId, 1);
    this.setState({
      [type === 2 ? "voilatorIdList" : "voilatorPersonList"]: temp,
    });
  };
  searchActiveUser = async (inputString, callback) => {
    // const contentType = { "Content-Type": "application/x-www-form-urlencoded" };
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      search: inputString,
      projectId: this.state.selectedProjectId || this.state.projectId || null,
    };
    await axios
      .get(Url.userSearch, {
        params: requestParams,
        headers: {
          accept: "application/json",
        },
      })
      .then(async (response) => {
        if (response.data.status === 200) {
          callback(response.data);
          await this.setState({
            searchData: { ...this.state.searchData, ...response.data },
          });
        }
      })
      .catch((error) => {});
  };
  searchClientEmployee = async (inputString, callback) => {
    FetchEMList({ search: inputString })
      .then(async (response) => {
        console.log(response);

        if (response.status === 200) {
          callback(response.data);
          await this.setState({
            searchEmployeeData: {
              ...this.state.searchEmployeeData,
              ...response.data,
            },
          });
        }
      })
      .catch((error) => {});
  };
  render() {
    const { t } = this.props;
    const isOberserver = this.state.userData.designation_flag === 4;
    // console.log("current Uploads changes", this.state.selectedFile);
    console.log("param_listttt ", this.state);
    return (
      <>
        {/* Data Loading  */}
        <div
          className="loader"
          style={{ display: this.state.dataLoading ? "block" : "none" }}
        >
          <LoadingImage />
        </div>
        <div className="rd-content">
          <div className="rd-left-content">
            <div className="rd-box">
              <Row>
                <Col>
                  <div className="form-group">
                    <label className="form-label">
                      Evidence
                      {this.state.param_list?.reportEvidenceMandotory && (
                        <abbr className="slds-required" title="required">
                          *{" "}
                        </abbr>
                      )}
                    </label>
                    {/* <label className="form-label">Image/Video</label> */}
                    <div className="padding-l-r">
                      <ReportDropzone
                        type="5"
                        disabledPlaceHolder
                        uploadFile={this._uploadFile}
                        removeFile={this._removeUploadedFile} // Add this line
                        clearDropZone={this.state.clearDropZone}
                      />
                    </div>
                  </div>

                  <div
                    className={`slds-form-element padding-l-r ${
                      this.state.observationError ? "slds-has-error" : ""
                    }`}
                  >
                    <div className="rd-box-head">
                      <div className="with-mic">
                        <label className="slds-form-element__label">
                          {this.state.reportType != "soi"
                            ? t("incidentDescription")
                            : t("observation")}
                          <abbr className="slds-required" title="required">
                            *{" "}
                          </abbr>
                        </label>
                      </div>
                      {this.state.observationURL ? (
                        <div className="audioPreviewer mt-2">
                          <AudioPlayer
                            src={this.state.observationURL}
                            showJumpControls={true}
                            layout="horizontal-reverse"
                            customVolumeControls={[]}
                            customAdditionalControls={[]}
                            style={{
                              width: "600px",
                            }}
                          />
                          <Button
                            variant="outline-primary"
                            onClick={() => this._removeAudioFile("observation")}
                          >
                            X
                          </Button>
                        </div>
                      ) : null}
                    </div>
                    <div className="slds-form-element__control">
                      <textarea
                        className="slds-textarea"
                        onChange={(event) =>
                          this._handleChange(event.target.value, "observation")
                        }
                        value={this.state.observationText}
                        placeholder={this._dynamicObservationPlaceHolder()}
                      ></textarea>
                    </div>

                    {!!this.state.observationError && (
                      <div class="slds-form-element__help" id="error-01">
                        {requiredMessage}
                      </div>
                    )}
                  </div>
                  <div>
                    {!isOberserver ? (
                      <>
                        {(this.props.reportType === "soi" ||
                          this.props.reportType === "ira" ||
                          this.props.reportType === "nm") &&
                          this.state.organisationSetting && (
                            <Row>
                              <Col>
                                <CompanyList
                                  optionList={this.state.companyList || []}
                                  onChangeHandle={this._companyChangeHandle}
                                  value={this.state.selectedCompanyId}
                                  hasError={this.state.companyError}
                                  searchable={
                                    this.props.reportType === "soi" ||
                                    this.props.reportType === "ira" ||
                                    this.props.reportType === "nm"
                                  }
                                  customSelectStyles={customSelectStyles}
                                />
                                {/* {!!this.state.serviceError && (
                          <p className="inputErrorMsg">{requiredMessage}</p>
                        )} */}
                              </Col>
                            </Row>
                          )}
                        <Row>
                          <Col>
                            <ServiceList
                              optionList={this.state.serviceList}
                              onChangeHandle={this._serviceChangeHandle}
                              value={this.state.selectedServiceId}
                              hasError={this.state.serviceError}
                              searchable={true}
                              customSelectStyles={customSelectStyles}
                            />
                            {/* {!!this.state.serviceError && (
                          <p className="inputErrorMsg">{requiredMessage}</p>
                        )} */}
                          </Col>
                          <Col>
                            <ProjectList
                              optionList={this.state.projectList}
                              onChangeHandle={this._projectChangeHandle}
                              value={this.state.selectedProjectId}
                              hasError={this.state.projectError}
                              searchable={true}
                              customPlaceHolder={"PPC"}
                              customSelectStyles={customSelectStyles}
                            />
                            {/* {!!this.state.projectError && (
                          <p className="inputErrorMsg">{requiredMessage}</p>
                        )} */}
                          </Col>
                        </Row>
                      </>
                    ) : null}
                  </div>
                  {/* Auto-filled Project Details (UAUC + organisation setting ON) */}
                  {this.state.organisationSetting && (
                    <div
                      className="mb-2"
                      style={{
                        border: "1px solid #eaeaea",
                        borderRadius: 8,
                        padding: 12,
                        margin: 12,
                      }}
                    >
                      <label className="slds-form-element__label">
                        Project Details
                      </label>
                      <div
                        style={{ display: "flex", flexWrap: "wrap", gap: 12 }}
                      >
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            Project Category
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={
                              this.state.projectAutoFill.projectCategory || ""
                            }
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            Region
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={this.state.projectAutoFill.region || ""}
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            State
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={this.state.projectAutoFill.state || ""}
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div
                          style={{ flex: "1 1 calc(50% - 6px)", minWidth: 0 }}
                        >
                          <label className="slds-form-element__label">
                            City
                          </label>
                          <input
                            className="form-control"
                            disabled
                            value={this.state.projectAutoFill.city || ""}
                            placeholder="Auto-filled"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    {/* <div className="rd-box-head">
                      <h3>Department/Contractor/Location (Select any one or all)</h3>
                    </div> */}
                    <Row>
                      {this.state.userData?.div_dept == 1 && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("division")}
                            optionList={this.state.divisionList}
                            onChangeHandle={this._divisionChangeHandle}
                            isRequired={true}
                            value={this.state.selectedDivisionId}
                            hasError={this.state.divisionError}
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ? "true" : "false"
                            }
                          />
                          {!!this.state.divisionError && (
                            <p className="inputErrorMsg">{requiredMessage}</p>
                          )}
                        </Col>
                      )}
                      <Col sm={6}>
                        <CommonDropdown
                          title={t("department")}
                          optionList={this.state.departmentList}
                          onChangeHandle={this._departmentChangeHandle}
                          isRequired={true}
                          value={this.state.selectedDepartmentId}
                          hasError={this.state.departmentError}
                          searchable={this.state.reportType === "soi"}
                          customSelectStyles={customSelectStyles}
                          customStyle={
                            this.state.reportType === "soi" ? "true" : "false"
                          }
                        />
                        {!!this.state.departmentError && (
                          <p className="inputErrorMsg">{requiredMessage}</p>
                        )}
                      </Col>
                      {!!(
                        this.state.showContractorDropdown &&
                        !Object.values(this.state.formHideField).includes(
                          "Contractor",
                        )
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("contractor")}
                            optionList={this.state.contractorList}
                            onChangeHandle={this._contractorChangeHandle}
                            isRequired={true}
                            value={this.state.selectedContractorId}
                            hasError={this.state.contractorError}
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ? "true" : "false"
                            }
                          />
                          {/* {!!this.state.contractorError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}
                        </Col>
                      )}

                      {!!(
                        this.state.showZoneDropdown &&
                        !Object.values(this.state.formHideField).includes(
                          "Zone",
                        ) &&
                        !Object.values(this.state.formHideField).includes(
                          "zone",
                        )
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("zone")}
                            optionList={this.state.zoneList}
                            onChangeHandle={this._zoneChangeHandle}
                            isRequired={true}
                            value={this.state.selectedZoneId}
                            hasError={this.state.zoneError}
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ? "true" : "false"
                            }
                          />
                          {/* {!!this.state.zoneError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}
                        </Col>
                      )}
                      {!!(
                        this.state.showLocationDropdown &&
                        !Object.values(this.state.formHideField).includes(
                          "Location",
                        ) &&
                        !Object.values(this.state.formHideField).includes(
                          "location",
                        )
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("location")}
                            optionList={this.state.locationList}
                            onChangeHandle={this._locationChangeHandle}
                            isRequired={true}
                            value={this.state.selectedLocationId}
                            hasError={this.state.locationError}
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ? "true" : "false"
                            }
                          />
                          {/* {!!this.state.locationError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}
                        </Col>
                      )}
                    </Row>
                  </div>
                </Col>
                <Col>
                  <div>
                    {/* <div className="rd-box-head">
                      <h3>{this._getDynamicAboutLabel()}</h3>
                    </div> */}
                    <Row>
                      {!!(
                        this.state.reportType != "ira" &&
                        !!this.state.param_list?.typeOfAct
                      ) && (
                        <Col col={6}>
                          <CommonDropdown
                            title={
                              this.state.reportType == "soi"
                                ? t("uaucType")
                                : t("typeOfAct")
                            }
                            optionList={this.state.typeActList}
                            onChangeHandle={this._typeactChangeHandle}
                            value={this.state.selectedTypeAct}
                            hasError={this.state.typeActError}
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ? "true" : "false"
                            }
                          />
                          {/* {!!this.state.typeActError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}
                        </Col>
                      )}
                      <Col sm={6}>
                        <CommonDropdown
                          title={t("activity")}
                          optionList={this.state.activityList}
                          onChangeHandle={this._activityChangeHandle}
                          value={this.state.selectedActivity}
                          hasError={this.state.activityError}
                          searchable={
                            this.state.reportType === "soi" ||
                            this.state.reportType === "nm"
                          }
                          customSelectStyles={customSelectStyles}
                          customStyle={
                            this.state.reportType === "soi" ||
                            this.state.reportType === "nm"
                              ? "true"
                              : "false"
                          }
                        />
                        {/* {!!this.state.activityError && (
                          <p className="inputErrorMsg">{requiredMessage}</p>
                        )} */}
                      </Col>

                      {/* Sub-Activity (UAUC/NM/IRA + organisation setting ON) */}
                      {!!(
                        (this.state.reportType === "soi" ||
                          this.state.reportType === "nm" ||
                          this.state.reportType === "ira") &&
                        this.state.param_list?.subActivity &&
                        this.state.subActivityList?.length > 0
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title="Sub-Activity"
                            optionList={this.state.subActivityList}
                            onChangeHandle={this._subActivityChangeHandle}
                            isRequired={true}
                            value={this.state.selectedSubActivity}
                            hasError={this.state.subActivityError}
                            searchable={
                              this.state.reportType === "soi" ||
                              this.state.reportType === "ira" ||
                              this.state.reportType === "nm"
                            }
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ||
                              this.state.reportType === "ira" ||
                              this.state.reportType === "nm"
                                ? "true"
                                : "false"
                            }
                          />
                        </Col>
                      )}

                      {this.state.reportType != "ira" ? (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("riskLevel")}
                            optionList={this.state.severityList}
                            onChangeHandle={this._severityChangeHandle}
                            value={this.state.selectedSeverity}
                            hasError={this.state.severityError}
                          />
                          {/* {!!this.state.severityError && (
                            <p className="inputErrorMsg">{requiredMessage}</p>
                          )} */}
                        </Col>
                      ) : null}

                      {!!(
                        this.state.reportType == "soi" &&
                        !!this.state.param_list?.barrier
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("barrierImmediateCause")}
                            customPlaceHolder="Immediate Cause"
                            optionList={this.state.barrierList}
                            onChangeHandle={this._barrierChangeHandle}
                            value={this.state.selectedBarrier}
                            hasError={this.state.barrierError}
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ? "true" : "false"
                            }
                          />
                          {/* {!!this.state.barrierError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}
                        </Col>
                      )}

                      {!!(
                        this.state.reportType != "ira" &&
                        !!this.state.param_list?.hazard
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("hazard")}
                            optionList={this.state.hazardList}
                            onChangeHandle={this._hazardChangeHandle}
                            isRequired
                            value={this.state.selectedHazardId}
                            hasError={this.state.hazardError}
                            searchable={
                              this.state.reportType === "soi" ||
                              this.state.reportType === "nm"
                            }
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ||
                              this.state.reportType === "nm"
                                ? "true"
                                : "false"
                            }
                          />
                          {/* {!!this.state.hazardError && (
                              <p className="inputErrorMsg">{requiredMessage}</p>
                            )} */}
                        </Col>
                      )}

                      {!!(
                        (this.state.reportType === "soi" ||
                          this.state.reportType === "nm") &&
                        this.state.param_list?.subHazard &&
                        this.state.subHazardList?.length > 0
                      ) && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("subHazard")}
                            optionList={this.state.subHazardList}
                            onChangeHandle={this._subHazardChangeHandle}
                            isRequired={true}
                            value={this.state.selectedSubHazardId}
                            hasError={this.state.subHazardError}
                            searchable={
                              this.state.reportType === "soi" ||
                              this.state.reportType === "nm"
                            }
                            customSelectStyles={customSelectStyles}
                            customStyle={
                              this.state.reportType === "soi" ||
                              this.state.reportType === "nm"
                                ? "true"
                                : "false"
                            }
                          />
                        </Col>
                      )}

                      {!!(this.state.reportType === "ira") && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("incidentType")}
                            optionList={this.state.typeIncidentList}
                            onChangeHandle={this._typeIncidentChangeHandle}
                            isRequired={true}
                            value={this.state.selectedIncidentTypeId}
                            hasError={this.state.incidentTypeError}
                          />
                        </Col>
                      )}
                      {!!this.state.param_list?.incidentDate && (
                        <Col sm={6}>
                          <div>
                            <label className="slds-form-element__label">
                              {t("incidentDate")}
                            </label>
                            <div className="calender-div">
                              <DatePicker
                                selected={this.state.selectedIncidentDate}
                                maxDate={this.state.maxDatepickerDate}
                                onChange={(jsDate) =>
                                  this._handleChange(jsDate, "incident_date")
                                }
                              />
                              <Calendar className="calender-icon" />
                            </div>
                          </div>
                        </Col>
                      )}

                      {!!this.state.param_list?.incidentTime && (
                        <Col sm={6}>
                          <div>
                            <label className="slds-form-element__label">
                              {t("incidentTime")}
                            </label>
                            <div className="calender-div slds-form-element__control">
                              <TimePicker
                                timeMode="12"
                                onTimeChange={(timeOptions) =>
                                  this._onTimeChange(timeOptions)
                                }
                                time={this.state.selectedIncidentTime}
                                closeOnOutsideClick={false}
                                meridiem={this.state.selectedTimeMeridiem}
                              />
                            </div>
                          </div>
                        </Col>
                      )}

                      {(this.state.param_list?.activeUser ||
                        this.state.param_list?.clientEmployeeMaster ||
                        this.state.param_list?.personId ||
                        this.state.reportType !== "soi") && (
                        <div
                          className="mb-2"
                          style={{
                            border: "1px solid #eaeaea",
                            borderRadius: 8,
                            padding: 12,
                            margin: 12,
                          }}
                        >
                          <p className="clide-v2-fs-5 mb-0 pl-1 pt-1 slds-form-element__label">
                            {t("involvedPersonDetails")}
                          </p>
                          <Row>
                            {this.state.reportType !== "soi" && (
                              <>
                                {(!!this.state.param_list?.person ||
                                  !!this.state.param_list
                                    ?.nameOfInjuredPerson) && (
                                  <Col sm={6} className="my-2">
                                    <div className="slds-form-element">
                                      <label className="slds-form-element__label">
                                        {this._getDynamicPersonNameLabel()}
                                      </label>
                                      <div className="d-flex slds-form-element__control">
                                        <input
                                          className={`slds-input col-lg-10 ${
                                            this.state.incidentPersonNameError
                                              ? "is-invalid"
                                              : "border"
                                          }`}
                                          value={this.state.personName}
                                          onChange={(event) =>
                                            this._handleChange(
                                              event.target.value,
                                              "person_name",
                                            )
                                          }
                                          placeholder={`${t("addMultiple")} ${
                                            this.state.reportType == "nm"
                                              ? t("employeeName")
                                              : t("injuredEmployeeName")
                                          } `}
                                        />

                                        <ErrorBlock
                                          message={t(
                                            "enterAtLeastOneIncidentPerosonName",
                                          )}
                                        />

                                        {/* <img src={require("assets/sls-icons/V2. New Development/ADD2.svg")} className=" ml-2 cursor-pointer svg-icons" onClick={this._addPersonName} /> */}
                                      </div>
                                      {this.state.personNameList.map(
                                        (personItem, personIndex) => (
                                          <div
                                            className="d-flex justify-content-between mt-2"
                                            key={`person-${personIndex}`}
                                          >
                                            <span>{personItem}</span>
                                            {/* <XCircle
                                          className="cursor-pointer"
                                          onClick={() =>
                                            this._removePersonName(personIndex)
                                          }
                                        /> */}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </Col>
                                )}
                              </>
                            )}
                            {this.state.reportType == "soi" ? (
                              <Col sm={6} className="my-2">
                                {!!this.state.param_list?.person ? (
                                  <div className="slds-form-element">
                                    <label className="slds-form-element__label">
                                      {t("violatorName")}
                                    </label>
                                    <div className="d-flex slds-form-element__control">
                                      <input
                                        className={`slds-input col-lg-12 custom-input`}
                                        value={this.state.voilatorPersonName}
                                        onChange={(event) =>
                                          this.setState({
                                            voilatorPersonName:
                                              event.target.value,
                                          })
                                        }
                                        placeholder={t("enterViolatorName")}
                                      />

                                      <ErrorBlock
                                        message={t(
                                          "enterAtLeastOneIncidentPerosonName",
                                        )}
                                      />

                                      {/* <img src={require("assets/sls-icons/V2. New Development/ADD2.svg")} className=" ml-2 cursor-pointer svg-icons" onClick={() => this.state.voilatorPersonName !== "" && this._manageVoilatorState(this.state.voilatorPersonName, 1)} /> */}
                                    </div>
                                    {this.state.voilatorPersonList.map(
                                      (personItem, personIndex) => (
                                        <div
                                          className="d-flex justify-content-between mt-2"
                                          key={`person-${personIndex}`}
                                        >
                                          <span>{personItem}</span>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                ) : null}
                              </Col>
                            ) : null}

                            {!!this.state.param_list?.personId ? (
                              <Col sm={6} className="my-2">
                                <div className="slds-form-element">
                                  <label className="slds-form-element__label">
                                    {this.state.reportType == "soi"
                                      ? t("violator")
                                      : ""}{" "}
                                    {this.state.reportType == "nm"
                                      ? t("involvedPerson")
                                      : ""}{" "}
                                    {this.state.reportType == "ira"
                                      ? t("injuredEmployee")
                                      : ""}{" "}
                                    {t("id")}
                                  </label>
                                  <div className="d-flex slds-form-element__control mr-3">
                                    <input
                                      className={`slds-input col-lg-11 custom-input`}
                                      value={this.state.voilatorId}
                                      onChange={(event) =>
                                        this.setState({
                                          voilatorId: event.target.value,
                                        })
                                      }
                                      placeholder={`${t("enter")} ${
                                        this.state.reportType == "soi"
                                          ? t("violator")
                                          : ""
                                      } ${
                                        this.state.reportType == "nm"
                                          ? t("employee")
                                          : ""
                                      } ${t("id")}`}
                                    />

                                    <ErrorBlock
                                      message={t(
                                        "enterAtLeastOneIncidentEmployeeName",
                                      )}
                                    />

                                    <img
                                      src={require("assets/sls-icons/V2. New Development/ADD2.svg")}
                                      className=" ml-2 cursor-pointer svg-icons"
                                      onClick={() => {
                                        if (
                                          this.state.voilatorPersonName !==
                                            "" ||
                                          (this.state.personName !== "" &&
                                            this.state.voilatorId !== "")
                                        ) {
                                          if (this.state.personName !== "") {
                                            this._addPersonName();
                                          } else {
                                            this._manageVoilatorState(
                                              this.state.voilatorPersonName,
                                              1,
                                            );
                                          }
                                          this._manageVoilatorState(
                                            this.state.voilatorId,
                                            2,
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                  {this.state.voilatorIdList.map(
                                    (personItem, personIndex) => (
                                      <div
                                        className="d-flex justify-content-between mt-2"
                                        key={`person-${personIndex}`}
                                      >
                                        <span>{personItem}</span>
                                        <XCircle
                                          className="cursor-pointer"
                                          onClick={() => {
                                            this.removeVoilator(personIndex);

                                            this.removeVoilator(personIndex, 2);
                                            if (
                                              this.state.personNameList?.length
                                            ) {
                                              this._removePersonName(
                                                personIndex,
                                              );
                                            }
                                          }}
                                        />
                                      </div>
                                    ),
                                  )}
                                </div>
                              </Col>
                            ) : null}
                          </Row>
                          {!!(
                            this.state.selectedServiceId !== null &&
                            this.state.selectedProjectId !== null &&
                            // (!!this.state.param_list?.activeUser ||
                            //   !!this.state.param_list?.employeeSearch)
                            !!this.state.param_list?.activeUser
                          ) && (
                            <Col sm={12} className="my-2">
                              <div className="slds-form-element">
                                <label className="slds-form-element__label">
                                  {t("activeUser")}
                                </label>
                                <div className="w-100">
                                  <AsyncSelect
                                    isMulti
                                    cacheOptions
                                    onChange={(data) => {
                                      const items = data?.map((el) => {
                                        return {
                                          ...el,
                                          incident_person_id: el?.value,
                                          incident_person_name: el?.label,
                                        };
                                      });
                                      this.setState({
                                        searchFiledUsers: items,
                                      });
                                    }}
                                    placeholder={t("activeUser")}
                                    loadOptions={(input, callback) => {
                                      if (this.timeout)
                                        clearTimeout(this.timeout);
                                      this.timeout = setTimeout(() => {
                                        this.searchActiveUser(input, (data) => {
                                          const items = data?.data.map(
                                            (element) => {
                                              return {
                                                ...element,
                                                label: element?.name,
                                                value: element?.id,
                                              };
                                            },
                                          );
                                          callback(items);
                                        });
                                      }, 1000);
                                    }}
                                  />
                                </div>

                                {/* {this.state.personNameList.map((personItem, personIndex) => (
                                  <div className="d-flex justify-content-between mt-2" key={`person-${personIndex}`}>
                                    <span>{personItem}</span>
                                  </div>
                                ))} */}
                              </div>
                            </Col>
                          )}
                          {!!(
                            this.state.selectedServiceId !== null &&
                            this.state.selectedProjectId !== null &&
                            !!this.state.param_list?.clientEmployeeMaster
                          ) && (
                            <Col sm={12} className="my-2">
                              <div className="slds-form-element">
                                <label className="slds-form-element__label">
                                  {t("searchEmployee")}
                                </label>
                                <div className="w-100">
                                  <AsyncSelect
                                    isMulti={true}
                                    cacheOptions
                                    onChange={(data) => {
                                      this.setState({
                                        searchEmployeeUsers: data,
                                      });
                                    }}
                                    placeholder={t("searchEmployee")}
                                    loadOptions={(input, callback) => {
                                      if (this.timeout)
                                        clearTimeout(this.timeout);
                                      this.timeout = setTimeout(() => {
                                        this.searchClientEmployee(
                                          input,
                                          (data) => {
                                            const items = data?.map(
                                              (element) => {
                                                return {
                                                  ...element,
                                                  label: element?.displayName,
                                                  value:
                                                    element?.clientEmployeeId,
                                                };
                                              },
                                            );
                                            console.log(items);

                                            callback(items);
                                          },
                                        );
                                      }, 1000);
                                    }}
                                  />
                                </div>

                                {/* {this.state.personNameList.map((personItem, personIndex) => (
                                  <div className="d-flex justify-content-between mt-2" key={`person-${personIndex}`}>
                                    <span>{personItem}</span>
                                  </div>
                                ))} */}
                              </div>
                            </Col>
                          )}
                        </div>
                      )}

                      {this.state.reportType == "soi" &&
                        this.state.param_list?.previousDate && (
                          <Col sm={12}>
                            <div className="form-group">
                              <label className="slds-form-element__label">
                                Date of Occurrence
                                <abbr
                                  className="slds-required"
                                  title="required"
                                >
                                  *{" "}
                                </abbr>
                              </label>

                              <div className="calender-div">
                                <DatePicker
                                  maxDate={new Date()}
                                  minDate={subDays(new Date(), 7)}
                                  onChange={(date) =>
                                    this.setState({ selectedDate: date })
                                  }
                                  selected={this.state.selectedDate}
                                  dateFormat="dd/MM/yyyy"
                                />
                                <Calendar className="calender-icon" />
                              </div>
                            </div>
                          </Col>
                        )}

                      {!!(
                        this.state.reportType == "soi" &&
                        !!this.state.param_list?.riskBaseDueDate
                      ) && (
                        <Col sm={12}>
                          <div>
                            <label className="slds-form-element__label">
                              {this.state.param_list.riskBaseDueDate !== 2
                                ? t("manualDueDate")
                                : t("riskdueDate")}
                            </label>
                            <div className="calender-div">
                              <DatePicker
                                selected={this.state.selectedTargetDate}
                                minDate={this.state.maxDatepickerDate}
                                showTimeSelect
                                timeFormat="HH:mm"
                                dateFormat="dd/MM/yyyy HH:mm"
                                popperPlacement="top"
                                isRequired
                                disabled={
                                  this.state.param_list.riskBaseDueDate == 2
                                }
                                onChange={(jsDate) =>
                                  this._handleChange(jsDate, "target_date")
                                }
                              />
                              <Calendar
                                className="calender-icon"
                                disabled={
                                  this.state.param_list.riskBaseDueDate == 2
                                }
                                isRequired
                              />
                            </div>
                            {this.state.targetDateError && (
                              <p className="inputErrorMsg">
                                This is mandatory field
                              </p>
                            )}
                          </div>
                        </Col>
                      )}

                      {!!(this.state.reportType == "soi") && (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("resolveRights")}
                            optionList={
                              this.state.userData?.designation_flag != 6
                                ? [
                                    ...this.state.closingRightUserList,
                                    {
                                      id: 0,
                                      ["closing_right"]: "Self Resolve",
                                    },
                                  ]
                                : this.state.closingRightUserList
                            }
                            onChangeHandle={this._closingRightUserChangeHandle}
                            isRequired={true}
                            value={this.state.selectedClosingRightUserId}
                            hasError={this.state.closingRightUserError}
                          />
                          {/* {this.state.closingRightUserError && (
                            <p className="inputErrorMsg">
                              This is mandatory field
                            </p>
                          )} */}
                        </Col>
                      )}
                      {!!(this.state.reportType == "soi") &&
                      !!this.state.param_list?.source ? (
                        <Col sm={6}>
                          <CommonDropdown
                            title={t("source")}
                            optionList={this.props.sourceList}
                            onChangeHandle={(id) =>
                              this.setState({ sourceId: id })
                            }
                            isRequired={false}
                            value={this.state.sourceId}
                          />
                        </Col>
                      ) : null}

                      <Col sm={6} className="d-flex align-items-center">
                        {this.state.selectedClosingRightUserId === 0 && (
                          <div className="slds-form-element__control">
                            <div className="slds-checkbox">
                              <input
                                name="options"
                                id="checkbox-unique-id-164"
                                type="checkbox"
                                checked={this.state.isCheckboxChecked}
                                onChange={() =>
                                  this.setState({
                                    isCheckboxChecked:
                                      !this.state.isCheckboxChecked,
                                  })
                                }
                              />
                              <label
                                className="slds-checkbox__label"
                                for="checkbox-unique-id-164"
                              >
                                <span className="slds-checkbox_faux"></span>{" "}
                                <span className="slds-form-element__label">
                                  {t("immediateResolve")}
                                </span>
                              </label>
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                    {this.state.reportType == "soi" &&
                      (this.state.param_list?.controlMeasure ||
                        this.state.param_list?.existingControlMeasure ||
                        this.state.param_list?.recommendedControlMeasure) && (
                        <>
                          <Row>
                            <Col sm={6}>
                              <CommonDropdown
                                title={t("controlMeasure")}
                                optionList={this.state.controlMeasureList}
                                onChangeHandle={
                                  this._controlMeasureChangeHandle
                                }
                                isRequired={false}
                                searchable={true}
                                hasError={this.state.controlMeasureError}
                                customSelectStyles={customSelectStyles}
                              />
                            </Col>

                            <Col sm={6}>
                              <div className="slds-form-element">
                                <div className="rd-box-head">
                                  {/* <div className="with-mic">
                              <h3>Control Measure </h3>
                            </div> */}
                                  {!!this.state.controlMeasureURL && (
                                    <>
                                      <audio controls>
                                        <source
                                          src={this.state.controlMeasureURL}
                                        ></source>
                                      </audio>
                                      <Button
                                        variant="outline-primary"
                                        onClick={() =>
                                          this._removeAudioFile(
                                            "control_measure",
                                          )
                                        }
                                      >
                                        X
                                      </Button>
                                    </>
                                  )}
                                </div>
                                <div className="slds-form-element">
                                  {/* <label className="slds-form-element__label" for="textarea-id-01">Textarea Label</label> */}
                                  <textarea
                                    className="slds-textarea"
                                    placeholder={t(
                                      "writeControlMeasureDescription",
                                    )}
                                    onChange={(event) =>
                                      this._handleChange(
                                        event.target.value,
                                        "control_measure",
                                      )
                                    }
                                    value={this.state.controlMeasure}
                                  ></textarea>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    {this.state.selectedControlMeasureIds.length ? (
                      <Row>
                        <Col>
                          <Scrollbars style={{ height: "80px" }}>
                            <>
                              {this.state.selectedControlMeasureIds.map(
                                (data, index) => (
                                  <div
                                    key={index}
                                    className="d-flex justify-content-between px-4"
                                  >
                                    <p>{`${index + 1} - ${
                                      data.controlMeasure
                                    }`}</p>
                                    <div>
                                      <Trash
                                        onClick={() =>
                                          this._removeControlMeasure(data.id)
                                        }
                                        className="cursor-pointer common-red-2"
                                      />
                                    </div>
                                  </div>
                                ),
                              )}
                            </>
                          </Scrollbars>
                        </Col>
                      </Row>
                    ) : null}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <Modal
          show={this.state.showRecorderModal}
          dialogClassName="modal-90w"
          aria-labelledby="Voice Recording"
          onHide={() => this._showRecorder(false)}
          className="recordingModal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("record")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div>
                <Button onClick={this.startRecording} className="red-btn">
                  <Mic />
                </Button>
                <Button onClick={this.stopRecording} className="gray-btn">
                  <MicOff />
                </Button>
              </div>
              <div className="obervationRecording"></div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showRecorderModal}
          dialogClassName="modal-90w"
          aria-labelledby="Voice Recording"
          onHide={() => this._showRecorder(false)}
          className="recordingModal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="obervationRecording">
              <ReactMic
                record={this.state.recordAudio}
                className="sound-wave"
                onStop={this.onStop}
                strokeColor="#000000"
                mimeType="audio/mp3"
                // strokeColor="#000000"
                backgroundColor="#FF4081"
              />
            </div>

            <div className="modal-footer-btn">
              <Button onClick={this.startRecording} className="red-btn">
                <Mic /> {t("startRecording")}
              </Button>
              <Button onClick={this.stopRecording} className="gray-btn">
                <MicOff /> {t("stopRecording")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          centered
          show={this.state.sucesssPopup}
          className="recordingModal"
          onHide={this._closeSuccessPopup}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body className="text-center">
            <img
              className="submit-img"
              src={SubmitImage}
              alt={t("submitImage")}
            />
            <p className="report-submit-text"> {t("thankYouForReporting")}</p>
            <p className="report-submit-text"> {t("youHaveReported")}</p>
            <p className="report-submit-text">
              {this.state.reportNumber || 0} {this._reportType()}{" "}
              {t("tillToday")}
            </p>
            <div className="modal-footer-btn">
              <button
                type="submit"
                className="red-btn"
                onClick={this._closeSuccessPopup}
              >
                {t("gotoDashboardAUC")}
              </button>
              <button
                type="submit"
                className="red-btn"
                onClick={this._continueReporting}
              >
                {t("continueReportingAUC")}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {this.state.showResolveModal ? (
          <ResolvePopup
            show={this.state.showResolveModal}
            modalClose={() =>
              this.setState({ showResolveModal: !this.state.showResolveModal })
            }
            reportId={this.state.reportId}
          />
        ) : null}
        {this.state.showLowStoragePopup ? (
          <LowSpace
            message={this.state.lowStorageMessage}
            handleLowSpace={this._handleLowSpace}
          />
        ) : null}
      </>
    );
  }
}

export default compose(
  withRouter,
  withTranslation(["report", "util"]),
)(NmReport);
